$.fn.toggleHtml = function (t1, t2) {
  if (this.html() == t1) this.html(t2);
  else this.html(t1);
  return this;
};

$.fn.isOnScreen = function () {
  var win = $(window);

  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft(),
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

$(window).load(function () {
  $('.localization-form [data-lang]').on('click', function () {
    var lang = $(this).attr('data-lang');
    var form = $(this).closest('form');
    form.find('input[name="locale_code"]').val(lang);
    form.submit();
  });

  /* checkout */
  updatePayments();
  setInterval(function () {
    updatePayments();
  }, 500);
});

// function checkProductOptions() {
//   var error = false;
//   var quickview = $(this).closest('.quickview-popup');

//   $('.product-configure .product-custom-checkbox.required, .product-configure .product-custom-radio.required').each(
//     function () {
//       var cur = $(this);
//       quickview = cur.closest('.quickview-popup');
//       if (cur.find('input:checked').length < 1) {
//         error = true;
//       }
//     }
//   );

//   $('.product-configure .product-custom-select.required').each(function () {
//     var cur = $(this);
//     if (cur.find('option:selected').val() == '') {
//       error = true;
//     }
//   });

//   $('.product-configure .product-custom-text.required').each(function () {
//     var cur = $(this);
//     if (cur.find('input').val() == '' || cur.find('input').val() == ' ') {
//       error = true;
//     }
//   });

//   $('.product-configure .product-custom-textarea.required').each(function () {
//     var cur = $(this);
//     if (cur.find('textarea').val() == '' || cur.find('textarea').val() == ' ') {
//       error = true;
//     }
//   });

//   if (quickview.length > 0) {
//     var cartBtn = quickview.find('.product-info .add-cart');
//   } else {
//     var cartBtn = $('#productpage .product-info .cart .add-cart');
//   }

//   if (error) {
//     cartBtn.text(ajaxTranslations('Selecteer je optie'));
//     cartBtn.attr('disabled', 'disabled');
//     cartBtn.addClass('disabled');
//   } else {
//     cartBtn.html('<i class="bx bx-cart before hidden-xs"></i>' + window.Shopmonkey.translations.add_to_cart);
//     cartBtn.removeAttr('disabled');
//     cartBtn.removeClass('disabled');
//   }
// }

function checkProductOptions(element) {
  var error = false;
  var quickview = element.closest('.quickview-popup');
  console.log(quickview);

  // Bepaal de juiste container
  var container = quickview.length > 0 ? quickview : $('#productpage');

  // Check required checkboxes and radio buttons
  container
    .find('.product-configure .product-custom-checkbox.required, .product-configure .product-custom-radio.required')
    .each(function () {
      if ($(this).find('input:checked').length < 1) {
        error = true;
      }
    });

  // Check required selects
  container.find('.product-configure .product-custom-select.required').each(function () {
    if ($(this).find('option:selected').val() == '') {
      error = true;
    }
  });

  // Check required text inputs
  container.find('.product-configure .product-custom-text.required').each(function () {
    if ($.trim($(this).find('input').val()) == '') {
      error = true;
    }
  });

  // Check required textareas
  container.find('.product-configure .product-custom-textarea.required').each(function () {
    if ($.trim($(this).find('textarea').val()) == '') {
      error = true;
    }
  });

  // Selecteer de juiste Add-to-Cart knop
  var cartBtn =
    quickview.length > 0 ? quickview.find('.product-info .add-cart') : $('#productpage .product-info .cart .add-cart');

  // Update de knop afhankelijk van validatie
  if (error) {
    cartBtn.text(window.Shopmonkey.translations.select_option);
    cartBtn.attr('disabled', 'disabled').addClass('disabled');
  } else {
    cartBtn.html('<i class="bx bx-cart before hidden-xs"></i>' + window.Shopmonkey.translations.add_to_cart);
    cartBtn.removeAttr('disabled').removeClass('disabled');
  }
}

function checkGiftCart(cur) {
  var form = cur.closest('form');
  var error = false;
  var email = form.find('input[name="email"]');
  var customAmount = form.find('.custom-price-gift input').val();

  if (!isValidEmailAddress(email.val())) {
    error = true;
    email.addClass('error');
  } else {
    email.removeClass('error');
  }

  if (customAmount && (customAmount < 10 || customAmount > 500)) {
    error = true;
    form.find('.custom-price-gift input').addClass('error');
  } else {
    form.find('.custom-price-gift input').removeClass('error');
  }

  return error;
}

function repairForm(form, type) {
  var error = false;
  form.find('input').each(function (index, input) {
    if (!$(input).val() || $(input).val() == ' ') {
      if (type != 'load') {
        $(input).addClass('error');
      }
      error = true;
    } else {
      $(input).removeClass('error');
    }
  });

  if (!error) {
    form.find('.form-message').empty().removeClass('error success');
    // $.ajax({
    //   // url: 'https://cluster1.monkeydo.it/kristalmeester/api/v1/order/get',
    //   url: 'https://kristalmeester.monkeydo.it/returns/search',
    //   method: 'POST',
    //   timeout: 0,
    //   data: form.serialize(),
    // }).done(function (response) {
    //   console.log(response);
    //   if (response.type == 'error') {
    //     form.find('.form-message').addClass('error').html(ajaxTranslations(response.message.trim()));
    //   }
    //   if (response.type == 'success') {
    //     repairOrderProducts(response.order);
    //   }
    // });

    const formData = new FormData(document.querySelector('#return-form'));
    const json = JSON.stringify(Object.fromEntries(formData.entries()));

    console.log(json);

    fetch('https://kristalmeester.monkeydo.it/returns/search', {
      method: 'POST',
      body: json,
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': Shopify.locale,
      },
    })
      .then((response) => response.json()) // Convert to JSON
      .then((response) => {
        console.log(response);
        if (response.type === 'error') {
          document.querySelector('.form-message').classList.add('error');
          document.querySelector('.form-message').innerHTML = ajaxTranslations(response.message.trim());
        }
        if (response.type === 'success') {
          repairOrderProducts(response.order);
        }
      })
      .catch((error) => console.error('Fetch error:', error));
  }
}

function repairOrderProducts(order) {
  var resultWrap = $('.search-result');
  var productsWrap = resultWrap.find('.order-products');
  productsWrap.empty();
  if (order.status == 'FULFILLED') {
    if (order.products) {
      $.each(order.products, function (index, product) {
        var html = '';
        html +=
          '<div class="order-product col-xs-6 col-sm-4" data-order="' +
          order.number +
          '" data-id="' +
          product.id +
          '" data-title="' +
          product.title +
          '" data-code="' +
          product.sku +
          '">';
        html += '<a class="inner" href="javascript:;">';
        html += '<i class="bx bxs-check-circle"></i>';
        html += '<div class="image-wrap">';
        html +=
          '<img src="' +
          product.image.thumb.replace('50x50x2', '200x200x2') +
          '" alt="' +
          product.title +
          '" title="' +
          product.title +
          '" width="335" height="335">';
        html += '</div>';
        html += '<div class="info">';
        html += '<div class="product-title title-font">' + product.title + '</div>';
        html += '</div>';
        html += '</a>';
        html += '</div>';
        productsWrap.append(html);
      });
      resultWrap.removeClass('hidden');
      resultWrap.find('input[name="order"]').val(order.number);
      resultWrap.find('input[name="name"]').val(order.addressShippingName);
      resultWrap.find('input[name="phone"]').val(order.phone);
      resultWrap.find('input[name="email"]').val(order.email);
    }
  } else {
    $('#return-form')
      .find('.form-message')
      .addClass('error')
      .html(ajaxTranslations('Je order is nog niet geleverd. Om deze reden kan je nog geen reparatie aanvragen.'));
    resultWrap.addClass('d-none');
  }

  $('#repair').find('.summary').addClass('d-none');
}

function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function countrySelect(cur) {
  var countryCode = cur.find('option:selected').attr('data-country-code');
  var country = cur.find('option:selected').attr('data-country');
  console.log(countryCode);
  cur
    .closest('.country-select')
    .find('.cur-country')
    .html('<img src="https://flagcdn.com/w20/' + country + '.png"><span>' + countryCode + '</span>');
}
function toGoPrice(cur) {
  var url = addPageUrl;
  if (countryCode == 'nl') {
    var from = deliveryFromNL;
    var shipText = ajaxTranslations('Free shipping within The Netherlands');
  } else {
    var from = deliveryFrom;
    var shipText = ajaxTranslations('Free shipping!');
  }

  $.get(url + '?format=json', function (data) {
    // console.log(data);
    if (data.cart) {
      var total = data.cart.totals.grand_total;
      if (from > total) {
        var toPrice = from - total;
        $('[data-price-togo]').empty().html(money(toPrice));
      } else {
        $('[data-price-togo]')
          .closest('.free-del')
          .empty()
          .html('<span>' + shipText + '!</span>');
      }
    }
  });
}

$(document).ready(function () {
  if (document.querySelector('.triggerStock') != null) {
    document.querySelector('.triggerStock').addEventListener('click', function () {
      document.querySelector('.restock-alerts-notify-button').click();
    });
  }

  $('.order-products').on('click', '.order-product .inner', function () {
    var cur = $(this);
    cur.toggleClass('active');

    $(this).closest('.return-form-wrap').find('.products-inputs').empty();
    $('.order-products .order-product .inner.active').each(function () {
      $(this)
        .closest('.return-form-wrap')
        .find('.products-inputs')
        .append(
          '<input name="products[]" required type="hidden" value="' +
            $(this).closest('.order-product').attr('data-title') +
            ', ' +
            $(this).closest('.order-product').attr('data-code') +
            '">'
        );
    });
  });

  $('body').on('change', '.product-configure .custom-option input', function () {
    $(this).closest('.custom-option').addClass('active');
  });

  $('.faq .faq-item .tab').on('click', function () {
    var cur = $(this);
    if (cur.closest('.faq-item').hasClass('active')) {
      cur.closest('.faq-item').removeClass('active').find('.page').slideUp(200);
    } else {
      cur.closest('.faq-items').find('.faq-item.active').removeClass('active').find('.page').slideUp(200);
      cur.closest('.faq-item').addClass('active').find('.page').slideDown(200);
    }
  });

  // $('.product-delete').on('click', function () {
  //   var item = $(this).closest('tr');
  //   item.find('input[name="updates[]"]').val(0);
  //   item.closest('form').submit();
  // });

  $('[name="sort_by"]').on('change', function () {
    var value = $(this).val();
    $('#filter_form').find('input[name="sort_by"]').val(value);
    $('#filter_form').submit();
  });

  $('#collection .sidebar input, #collection .sidebar .sort select').change(function () {
    console.log('change');
    $(this).closest('form').submit();
  });

  var min;
  var max = $('.collection-filter-price').attr('data-max')
    ? $('.collection-filter-price').attr('data-max')
    : $('.collection-filter-price').attr('data-range-max');
  max = max / 100;
  $('.collection-filter-price').slider({
    range: true,
    min: 0,
    max: $('.collection-filter-price').attr('data-range-max') / 100,
    values: [$('.collection-filter-price').attr('data-min') / 100, max],
    step: 1,
    slide: function (event, ui) {
      $('.price-filter-range .min span').html(ui.values[0]);
      $('.price-filter-range .max span').html(ui.values[1]);
      $('#filter_form_min').val(ui.values[0]);
      $('#filter_form_max').val(ui.values[1]);
    },
    stop: function (event, ui) {
      $(this).closest('form').submit();
    },
  });

  $('#collectionLeesmeer').click(function () {
    $('.readmore, .readless').toggleClass('hidden');
    $('.col-description-below').toggleClass('desc-collapsed');
    $('.col-description-below').toggleClass('spacing-below');
    $('#collectionLeesmeer i').toggleClass('rotated');
  });

  // console.log('global.js');
  // $('iframe#snapwidget-widget').live('change', function(){
  //   console.log('go');
  //   $('.instagram-feed .placeholder').remove();
  // });

  // setTimeout(function(){
  //   $('iframe#snapwidget-widget').attr('src', 'https://snapwidget.com/embed/920497');
  //   $('.instagram-feed .placeholder').remove();
  // }, 3000);

  if ($('[data-price-togo]').length) {
    toGoPrice();
  }

  $('.greeting-main-title').on('click', function () {
    var cur = $(this);
    $(this)
      .closest('.greeting-block-outer')
      .find('.greeting-block')
      .slideToggle(function () {});
    cur.toggleClass('active');
  });

  $('.greeting-block textarea').on('keyup', function () {
    var message = $(this).val();
    var maxWords = $(this).attr('maxwords');
    countWords($(this), message, maxWords);
  });

  // document.getElementById('submit-newsletter').addEventListener('click', (e) => {
  //   console.log('Form submitted');

  //   // const newsletterBlock = document.getElementById('newsletter-block');

  //   // newsletterBlock.innerHTML = `
  //   //     <div class="text-wrapper">
  //   //         <h2>Thank you for subscribing!</h2>
  //   //         <p>We appreciate your interest and will keep you updated with our latest news.</p>
  //   //     </div>
  //   // `;
  // });

  /*
  TODO: Greetings
  if (greetingCode && $('.greeting-block').length) {
    $.get((greetingsUrl + '?format=json'), function(data){
    	$.each(data.collection.products, function(index, product){
      	if (product.code == greetingCode) {
        	var url = basicUrl + product.url + '?format=json';
          $.get((url), function(productData){
            var loop = 0;
            var correctArray = [];
            if (productData.product.variants) {
              $.each(productData.product.variants, function(index, variant){ 
                correctArray[variant.position - 1] = variant;
              });
            } else if (productData.product.variant) {
              correctArray = productData.product;
            }
            
            if (productData.product.variants) {
              $.each(correctArray, function(index, variant){
                var imgUrl = 'https://static.webshopapp.com/shops/'+shopId+'/files/'+variant.image+'/140x210x2/image.jpg';
                var container = $('.greeting-block .greeting-options');
                var option = $('<div class="option" data-vid="'+ variant.id +'" data-card="'+(loop*1+1)+'">').appendTo(container);
                var inner = $('<div class="inner">').appendTo(option);
                var zoom = $('<a class="zoom" data-fancybox href="'+imgUrl.replace('140x210x2','420x630x2')+'"><i class="fa fa-search-plus"></i></a>').appendTo(inner);
                var image = $('<div class="img-wrap"><img src="'+imgUrl+'">').appendTo(inner);
                if (!variant.stock.available) {
                  var label = $('<div class="stock-label">Uitverkocht</div>').appendTo(image);
                }
                var title = $('<div class="title">'+variant.title+' (€'+variant.price.price_incl.toFixed(2).replace('.', ',').replace(',00', '')+')</div>').appendTo(inner);
                loop++;
              });
            } else if (productData.product.variant) { 
                var imgUrl = 'https://static.webshopapp.com/shops/'+shopId+'/files/'+correctArray.image+'/140x210x2/image.jpg';
                var container = $('.greeting-block .greeting-options');
                var option = $('<div class="option" data-vid="'+ correctArray.id +'" data-card="'+(loop*1+1)+'">').appendTo(container);
                var inner = $('<div class="inner">').appendTo(option);
                var zoom = $('<a class="zoom" data-fancybox href="'+imgUrl.replace('140x210x2','420x630x2')+'"><i class="fa fa-search-plus"></i></a>').appendTo(inner);
                var image = $('<div class="img-wrap"><img src="'+imgUrl+'">').appendTo(inner);
                if (!correctArray.stock.available) {
                  var label = $('<div class="stock-label">Uitverkocht</div>').appendTo(image);
                }
                var title = $('<div class="title">'+correctArray.title+' (€'+correctArray.price.price_incl.toFixed(2).replace('.', ',').replace(',00', '')+')</div>').appendTo(inner);
            }
            
          });
          $.get((url), function(productData){
            var sku = $('.custom-card-form').data('sku');
            $.each(productData.product.custom, function(index, custom){
              if (custom.type == 'textarea') {
            		$('.custom-card-form').append('<textarea name="custom['+custom.id+']" id="product_configure_custom_'+custom.id+'">');
              } else if (custom.type == 'text') {
                $('.custom-card-form').append('<input name="custom['+custom.id+']" id="product_configure_custom_'+custom.id+'" value="'+ sku +'">');
              }
            });
          });
        }
      });
    });
  }
    */

  $('body').on('click', '.greeting-options .option', function () {
    var options = $(this).closest('.greeting-options');
    options.find('.option.active').removeClass('active');
    $(this).addClass('active');

    greeting();
  });

  $('.card-text textarea').on('change keyup paste', function () {
    greeting();
  });

  $('.greeting-block a.add-greeting').on('click', function () {
    var activeCardId = $('.greeting-options .option.active').attr('data-vid');
    var completeUrl = addUrl + activeCardId + '/';
    var form = $('.custom-card-form');
    $.ajax({
      url: completeUrl,
      data: form.serialize(),
      type: 'POST',
    }).done(function () {
      $('#gui-form-cart').submit();
    });
  });

  $('input[name="samen-inpakken"]').on('change', function () {
    var firstVid = false;
    var inpakProducten = [];
    var deleted = 0;
    var toDelete = $('#cart-page .cart-table .product[data-inpak-products]').length;
    var added = 0;
    var toAdd = 0;

    $('#cart-page .cart-table .product[data-inpak-products]').each(function () {
      var qid = $(this).attr('data-qid');
      var vid = $(this).attr('data-id');
      var inpakProduct = $(this).attr('data-inpak-products').split(',');
      if (!firstVid) {
        firstVid = $(this).attr('data-id');
      }
      inpakProducten = inpakProducten.concat(inpakProduct);

      var deleteUrl = $('.cadeaupapier-product').attr('data-delete-url') + qid + '/';
      $.ajax({
        url: window.Shopify.routes.root + 'cart/change.js',
        method: 'POST',
        data: {
          id: qid,
          quantity: 0,
        },
        dataType: 'json',
      }).done(function () {
        deleted += 1;
      });
    });

    if ($(this).is(':checked')) {
      Cookies.set('inpakSamen', 'set');
      toAdd = 1;
      var inpakProductenString = inpakProducten.join();
      $('.cadeaupapier-product textarea').val(inpakProductenString);

      var addUrlFull = addUrl + '/' + firstVid + '/';
      var data = $('.cadeaupapier-product form').serialize();

      $.ajax({
        type: 'POST',
        url: addUrlFull,
        data: data,
      }).done(function () {
        added += 1;
        console.log('added');
      });
    } else {
      Cookies.set('inpakSamen', false);

      toAdd = inpakProducten.length;
      $.each(inpakProducten, function (index, inpakProduct) {
        $('.cadeaupapier-product textarea').val(inpakProduct);

        var addUrlFull = addUrl + '/' + firstVid + '/';
        var data = $('.cadeaupapier-product form').serialize();

        $.ajax({
          type: 'POST',
          url: addUrlFull,
          data: data,
        }).done(function () {
          added += 1;
          console.log('added');
        });
      });
    }

    if (!toAdd && !toDelete) {
      location.reload();
      console.log('test');
    }

    $(document).ajaxComplete(function () {
      if (toAdd == added && toDelete == deleted) {
        location.reload();
        console.log('test123');
      }
    });
    // location.reload();
  });

  if (Cookies.get('inpakSamen') == 'set') {
    if ($('.cadeaupapier-product').length) {
      $('input[name="samen-inpakken"]').prop('checked', 'checked');

      var inpak = false;
      var inpakQid = false;
      var inpakVid = false;
      var totalInpakProducten = 0;

      var url = 'products/' + $('.cadeaupapier-product').data('url');
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json();
        })
        .then((cart) => {
          $.get(url + '?format=json', function (data) {
            inpakVid = data.product.id || '';
            var addUrl = $('.cadeaupapier-product').attr('data-add-url') + data.product.vid + '/';
            $('.cadeaupapier-product').attr('data-add-url', addUrl);

            var html = '<form>';
            html += '<textarea name="properties[gift_wrap]"></textarea>';
            html += '</form>';

            $('.cadeaupapier-product').append(html);

            var variantHtml = '<div class="inpak-varianten">';
            var inpakIncart = false;
            $.each(data.product.variants, function (index, variant) {
              var inCart = false;
              $.each(cart.items, function (index, product) {
                if (product.vid == variant.id) {
                  inCart = true;
                  inpakIncart = true;
                  $('#cadeaupapier-popup').attr('data-vid', variant.id);
                }
              });

              var variantImage = false;
              $.each(data.product.images, function (index, image) {
                if (variant.image_id === image.id) {
                  variantImage = image.src;
                }
              });

              variantHtml += '<div class="inpak-variant">';
              if (inCart) {
                variantHtml +=
                  '<a href="javascript:;" class="inpak-variant-inner active" data-vid="' +
                  variant.id +
                  '"><img src="' +
                  variantImage +
                  '" title="' +
                  variant.title +
                  '" alt="' +
                  variant.title +
                  '"></a>';
              } else {
                variantHtml +=
                  '<a href="javascript:;" class="inpak-variant-inner" data-vid="' +
                  variant.id +
                  '"><img src="' +
                  variantImage +
                  '" title="' +
                  variant.title +
                  '" alt="' +
                  variant.title +
                  '"></a>';
              }
              variantHtml += '</div>';
            });
            variantHtml += '</div>';
            variantHtml += '<div class="button-wrap">';
            if (inpakIncart) {
              variantHtml += '<a href="javascript:;" class="btn inpak-btn">Inpakken</a>';
            } else {
              variantHtml += '<a href="javascript:;" class="btn inpak-btn disabled">Inpakken</a>';
            }
            variantHtml += '</div>';

            $('#cadeaupapier-popup').append(variantHtml);

            $('#cart-page .cart-table .product').each(function () {
              var id = $(this).data('product-id');
              var qid = $(this).data('qid');
              var inpakTrue = $(this).attr('data-inpak-products');

              if (id == inpakVid && inpakTrue) {
                var inpakProducts = $(this).data('inpak-products').split(',');

                $.each(inpakProducts, function (index, inpakId) {
                  var inpakIdSplit = inpakId.split(':')[1];
                  inpakIdSplit = inpakIdSplit.trim();
                  if ($('#cart-page .cart-table .product[data-qid="' + inpakIdSplit + '"]').length) {
                    totalInpakProducten += 1;
                    console.log('totalInpakProducten', totalInpakProducten);
                  }
                  $('#cart-page .cart-table .product[data-qid="' + inpakIdSplit + '"] .add-wrapping-input').prop(
                    'checked',
                    'checked'
                  );
                });

                if (totalInpakProducten == 0) {
                  $.ajax({
                    url: '/cart/change.js',
                    method: 'POST',
                    data: {
                      id: qid,
                      quantity: 0,
                    },
                    dataType: 'json',
                  }).done(function () {
                    location.reload();
                  });
                }
              }
            });
          });
        });

      $('.add-wrapping-input').on('change', function () {
        var idString = '';
        var vidInpak = false;
        $('#cart-page .cart-table .product').each(function () {
          var id = $(this).data('product-id');
          var qid = $(this).data('qid');
          var vid = $(this).data('id');
          var sku = $(this).data('sku');
          var inpakTrue = $(this).attr('data-inpak-products');

          console.log('so far ok');

          if ($(this).find('.add-wrapping-input:checked').length) {
            idString += sku + ': ' + qid + ', ';
          }

          if (id == inpakVid && inpakTrue) {
            inpak = true;
            inpakQid = qid;
            vidInpak = vid;
          }
        });

        $('.cadeaupapier-product textarea').val(idString.substring(0, idString.length - 2));

        if (vidInpak) {
          var addUrlFull = addUrl + '/' + vidInpak + '/';
        }
        var deleteUrl = $('.cadeaupapier-product').attr('data-delete-url') + inpakQid + '/';
        var data = $('.cadeaupapier-product form').serialize();
        if (!$('.cadeaupapier-product form textarea').val()) {
          var empty = true;
        } else {
          var empty = false;
        }

        if (empty) {
          $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            data: {
              id: inpakQid,
              quantity: 0,
            },
            dataType: 'json',
          }).done(function () {
            location.reload();
          });
        } else {
          if (!inpak) {
            $('.open-cadeaupapier-popup').trigger('click');
          } else {
            $.ajax({
              url: '/cart/change.js',
              method: 'POST',
              data: {
                id: inpakQid,
                quantity: 0,
              },
              dataType: 'json',
            }).done(function () {
              $.ajax({
                type: 'POST',
                url: addUrlFull,
                data: data,
              }).done(function () {
                location.reload();
              });
            });
          }
        }
      });

      $('#cadeaupapier-popup').on('click', '.inpak-variant-inner', function () {
        $('#cadeaupapier-popup .inpak-variant-inner').removeClass('active');
        $(this).addClass('active');
        $('#cadeaupapier-popup .inpak-btn').removeClass('disabled');

        $(this).closest('#cadeaupapier-popup').attr('data-vid', $(this).attr('data-vid'));
      });

      $('#cadeaupapier-popup').on('click', '.inpak-btn', function () {
        var idString = '';
        var vidInpak = false;
        $('#cart-page .cart-table .product').each(function () {
          var id = $(this).data('product-id');
          var qid = $(this).data('qid');
          var vid = $(this).data('id');
          var sku = $(this).data('sku');
          var inpakTrue = $(this).attr('data-inpak-products');

          if ($(this).find('.add-wrapping-input:checked').length) {
            idString += sku + ': ' + qid + ', ';
          }

          if (id == inpakVid && inpakTrue) {
            inpak = true;
            inpakQid = qid;
            vidInpak = vid;
          }
        });
        $('.cadeaupapier-product textarea').val(idString.substring(0, idString.length - 2));

        var addUrlFull = addUrl + '/' + $('#cadeaupapier-popup').attr('data-vid') + '/';
        var data = $('.cadeaupapier-product form').serialize();
        if (!$('.cadeaupapier-product form textarea').val()) {
          var empty = true;
        } else {
          var empty = false;
        }

        if (empty) {
          $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            data: {
              id: inpakQid,
              quantity: 0,
            },
            dataType: 'json',
          }).done(function () {
            location.reload();
          });
        } else {
          if (!inpak) {
            $.ajax({
              type: 'POST',
              url: addUrlFull,
              data: data,
            }).done(function () {
              location.reload();
            });
          } else {
            $.ajax({
              url: '/cart/change.js',
              method: 'POST',
              data: {
                id: inpakQid,
                quantity: 0,
              },
              dataType: 'json',
            }).done(function () {
              $.ajax({
                type: 'POST',
                url: addUrlFull,
                data: data,
              }).done(function () {
                location.reload();
              });
            });
          }
        }
      });
    }
  } else {
    if ($('.cadeaupapier-product').length) {
      var inpak = false;
      var inpakQid = false;
      var inpakVid = false;
      var totalInpakProducten = 0;
      var qidToTitle = {};

      var url = 'products/' + $('.cadeaupapier-product').data('url');
      var cart = false;

      fetch('/cart.js')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json();
        })
        .then((cart) => {
          $.get(url + '?format=json', function (data) {
            $.each(cart.items, function (index, cartProduct) {
              qidToTitle[cartProduct.id] = cartProduct.title;
            });

            console.log(qidToTitle);

            inpakVid = data.product?.id || null;
            var addUrl = $('.cadeaupapier-product').attr('data-add-url') + data.product.vid + '/';
            $('.cadeaupapier-product').attr('data-add-url', addUrl);
            var html = '<form>';

            html += '<textarea name="properties[gift_wrap]"></textarea>';

            html += '</form>';
            $('.cadeaupapier-product').append(html);

            var variantHtml = '<div class="inpak-varianten">';
            var inpakIncart = false;
            $.each(data.product.variants, function (index, variant) {
              var inCart = false;
              $.each(cart.items, function (index, product) {
                if (product.vid == variant.id) {
                  inCart = true;
                  inpakIncart = true;
                  $('#cadeaupapier-popup').attr('data-vid', variant.id);
                }
              });

              var variantImage = false;
              $.each(data.product.images, function (index, image) {
                if (variant.image_id === image.id) {
                  variantImage = image.src;
                }
              });

              variantHtml += '<div class="inpak-variant">';
              if (inCart) {
                variantHtml +=
                  '<a href="javascript:;" class="inpak-variant-inner active" data-vid="' +
                  variant.id +
                  '"><img src="' +
                  variantImage +
                  '" title="' +
                  variant.title +
                  '" alt="' +
                  variant.title +
                  '"></a>';
              } else {
                variantHtml +=
                  '<a href="javascript:;" class="inpak-variant-inner" data-vid="' +
                  variant.id +
                  '"><img src="' +
                  variantImage +
                  '" title="' +
                  variant.title +
                  '" alt="' +
                  variant.title +
                  '"></a>';
              }
              variantHtml += '</div>';
            });
            variantHtml += '</div>';
            variantHtml += '<div class="button-wrap">';
            if (inpakIncart) {
              variantHtml += '<a href="javascript:;" class="btn inpak-btn">Inpakken</a>';
            } else {
              variantHtml += '<a href="javascript:;" class="btn inpak-btn disabled">Inpakken</a>';
            }
            variantHtml += '</div>';

            $('#cadeaupapier-popup').append(variantHtml);

            $('#cart-page .cart-table .product').each(function () {
              var id = $(this).data('product-id');
              var qid = $(this).attr('data-qid');
              var vid = $(this).attr('data-id');
              var inpakTrue = $(this).attr('data-inpak-products');

              console.log('id:', id, 'inpakVid:', inpakVid);

              if (id == inpakVid && inpakTrue) {
                var inpakProducts = $(this).data('inpak-products').split(',');
                console.log('inpakProducts', inpakProducts);

                var inpakProductQid = inpakProducts[0].split(':')[1].trim();
                var inpakProductSku = inpakProducts[0].split(':')[0].trim();
                var inpakProductTitle = qidToTitle[inpakProductQid];
                $(this)
                  .find('.extra-info .variant')
                  .after('<li class="inpak-product"><b>Ingepakt product:</b> ' + inpakProductTitle + '</li>');
                $(this)
                  .find('.change-wrapping a')
                  .attr('data-qid', inpakProductQid)
                  .attr('data-sku', inpakProductSku)
                  .attr('data-vid', vid);

                $.each(inpakProducts, function (index, inpakId) {
                  var inpakIdSplit = inpakId.split(':')[1];
                  inpakIdSplit = inpakIdSplit.trim();
                  if ($('#cart-page .cart-table .product[data-qid="' + inpakIdSplit + '"]').length) {
                    totalInpakProducten += 1;
                  }
                  $('#cart-page .cart-table .product[data-qid="' + inpakIdSplit + '"] .add-wrapping-input').prop(
                    'checked',
                    'checked'
                  );
                });

                if (totalInpakProducten == 0) {
                  var deleteUrl = $('.cadeaupapier-product').attr('data-delete-url') + qid + '/';
                  $.ajax({
                    type: 'POST',
                    url: deleteUrl,
                  }).done(function () {
                    location.reload();
                  });
                }
              }
            });
          });
        });

      $('.change-wrapping a').on('click', function () {
        var qid = $(this).attr('data-qid');
        var sku = $(this).attr('data-sku');
        var vid = $(this).attr('data-vid');

        $('#cadeaupapier-popup .inpak-variant-inner[data-vid="' + vid + '"]').trigger('click');

        $('#cadeaupapier-popup .inpak-btn').attr('data-qid', qid).attr('data-sku', sku);
        // $('.open-cadeaupapier-popup').trigger('click');
      });

      $('.add-wrapping-input').on('change', function () {
        var cur = $(this);
        var idString = '';
        var vidInpak = false;
        var curQid = cur.closest('.product').attr('data-qid');
        var curSku = cur.closest('.product').attr('data-sku');

        $('#cart-page .cart-table .product').each(function () {
          var id = $(this).data('product-id');
          var qid = $(this).data('qid');
          var vid = $(this).data('id');
          var sku = $(this).data('sku');
          var inpakTrue = $(this).attr('data-inpak-products');

          if (id == inpakVid && inpakTrue && inpakTrue.includes(curQid)) {
            inpak = true;
            inpakQid = qid;
            vidInpak = vid;
          }
        });

        var deleteUrl = $('.cadeaupapier-product').attr('data-delete-url') + inpakQid + '/';
        if (!cur.is(':checked')) {
          var empty = true;
        } else {
          var empty = false;
        }

        if (empty) {
          $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            data: {
              id: inpakQid,
              quantity: 0,
            },
            dataType: 'json',
          }).done(function () {
            location.reload();
          });
        } else {
          $('.open-cadeaupapier-popup').trigger('click');
          $('#cadeaupapier-popup .inpak-btn').attr('data-qid', curQid).attr('data-sku', curSku);
          if (vidInpak) {
            $('#cadeaupapier-popup .inpak-variant-inner[data-vid="' + vidInpak + '"]').trigger('click');
          } else {
            $('#cadeaupapier-popup .inpak-variant-inner').removeClass('active');
          }
        }
      });

      $('#cadeaupapier-popup').on('click', '.inpak-variant-inner', function () {
        $('#cadeaupapier-popup .inpak-variant-inner').removeClass('active');
        $(this).addClass('active');
        $('#cadeaupapier-popup .inpak-btn').removeClass('disabled');

        $(this).closest('#cadeaupapier-popup').attr('data-vid', $(this).attr('data-vid'));
      });

      $('#cadeaupapier-popup').on('click', '.inpak-btn', function () {
        var idString = '';
        var vidInpak = false;
        var curQid = $(this).attr('data-qid');
        var curSku = $(this).attr('data-sku');

        $('#cart-page .cart-table .product').each(function () {
          var id = $(this).data('product-id');
          var qid = $(this).data('qid');
          var vid = $(this).data('id');
          var sku = $(this).data('sku');
          var inpakTrue = $(this).attr('data-inpak-products');

          if (id == inpakVid && inpakTrue && inpakTrue.includes(curQid)) {
            inpak = true;
            inpakQid = qid;
            vidInpak = vid;
          }
        });

        idString += curSku + ': ' + curQid;

        $('.cadeaupapier-product textarea').val(idString);

        var deleteUrl = $('.cadeaupapier-product').attr('data-delete-url') + inpakQid + '/';
        var addUrlFull = addUrl + '/' + $('#cadeaupapier-popup').attr('data-vid') + '/';
        var data = $('.cadeaupapier-product form').serialize();

        if (!inpak) {
          $.ajax({
            type: 'POST',
            url: addUrlFull,
            data: data,
          }).done(function () {
            location.reload();
          });
        } else {
          $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            data: {
              id: inpakQid,
              quantity: 0,
            },
            dataType: 'json',
          }).done(function () {
            $.ajax({
              type: 'POST',
              url: addUrlFull,
              data: data,
            }).done(function () {
              location.reload();
            });
          });
        }
      });
    }
  }

  /* live compare */
  $('.open-compare').on('click', function () {
    $(this).closest('.compare-pop').toggleClass('open');
    $('.compare-overlay').toggleClass('active');
  });
  $('.compare-overlay').on('click', function () {
    $('.compare-pop').removeClass('open');
    $('.compare-overlay').removeClass('active');
  });

  // $('body').on('change', '.compare-check', function () {
  //   var cur = $(this);
  //   if ($(this).is(':checked')) {
  //     var url = cur.data('add-url');
  //   } else {
  //     var url = cur.data('del-url');
  //   }

  //   $.ajax({
  //     type: 'POST',
  //     url: url,
  //   }).done(function () {
  //     if (template == 'pages/compare.rain') {
  //       location.reload();
  //     }
  //   });

  //   setTimeout(function () {
  //     compare();
  //   }, 500);
  // });

  // $('body').on('click', '.delete-compare', function () {
  //   var url = $(this).attr('data-del-url');

  //   $(this).closest('.compare-product').remove();
  //   $.ajax({
  //     type: 'POST',
  //     url: url,
  //   });

  //   setTimeout(function () {
  //     compare();
  //   }, 500);
  // });

  if ($('.country-select').length) {
    countrySelect($('.country-select select'));

    $('.country-select select').on('change', function () {
      countrySelect($(this));
    });
  }

  // repairForm($('#return-form'), 'load');
  $('#return-form').submit(function (e) {
    e.preventDefault();
    repairForm($(this), 'submit');
  });

  $('#return-form-2 .btn').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var type = form.attr('type');
    // console.log(type);
    var error = false;
    // var requiredFields = form.find('input.required, textarea.required, select.required');
    var requiredFields = form.find('input, textarea, select').filter('[required]');

    $.each(requiredFields, function (key, field) {
      if ($(this).val() == '' || $(this).val() == ' ' || $(this).val() == null) {
        $(this).addClass('error');

        var cur = $(this);
        if (cur.is('select')) {
          cur.closest('.custom-select').addClass('error');
        }
        error = true;
      } else {
        $(this).removeClass('error');

        if ($(this).closest('.image-select').length) {
          $(this).closest('.image-select').removeClass('error');
        }

        var cur = $(this);
        if (cur.is('select')) {
          cur.closest('.custom-select').removeClass('error');
        }
      }

      var name = $(this).attr('name');
      if (name == 'email' && !validateEmail($(this).val())) {
        $(this).addClass('error');
        error = true;
      } else if (name == 'email' && validateEmail($(this).val())) {
        $(this).removeClass('error');
      }
    });

    if (!error) {
      $.ajax({
        type: 'POST',
        url: 'https://kristalmeester.monkeydo.it/returns/submit',
        data: form.serialize(),
        headers: {
          'Accept-Language': Shopify.locale,
        },
      }).done(function (json) {
        console.log(json);
        if (json.type == 'success') {
          form
            .find('.form-message')
            .removeClass('error hidden')
            .addClass('success')
            .html(ajaxTranslations(json.message));
          setTimeout(function () {
            form.find('.form-message').removeClass('success').addClass('hidden').html('');
          }, 5000);
        } else {
          form
            .find('.form-message')
            .removeClass('success hidden')
            .addClass('error')
            .html(ajaxTranslations(json.message));
        }
      });
    }
  });

  $('img.zoom')
    .wrap('<span class="zoom-outer" style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({ url: $(this).attr('src') });

  if (!Cookies.get('alertbar') && $('.alertbar').length) {
    $('.alertbar').removeClass('hidden');
  }

  $('.alertbar-close').on('click', function () {
    $('.alertbar').addClass('hidden');
    Cookies.set('alertbar', true);
  });

  $('.add-gift-card-live').on('click', function () {
    var form = $(this).closest('form');
    var url = form.attr('action');
    var btn = $(this);
    var btnText = $(this).html();
    var quantity = form.find('input[name="quantity"]').val();
    var added = 0;

    error = checkGiftCart($(this));

    if (!error) {
      $.ajax({
        type: 'POST',
        data: form.serialize(),
        url: url,
      });

      $(document).ajaxComplete(function () {
        added += 1;
        if (added < quantity) {
          $.ajax({
            type: 'POST',
            data: form.serialize(),
            url: url,
          });
        } else {
          $(document).unbind('ajaxComplete');
          btn.html(btnText);
          if ($(window).width() < 768) {
            createMessage(data);
          } else {
            $('.open-upsell').trigger('click');
          }
          updateCart(btn, btnText, 'add');
        }
      });
    }
  });

  $('.custom-price-gift input').on('keyup', function () {
    $(this).attr('name', 'amount');
    $('.gift-prices input').prop('checked', false);
    if ($(this).val() == '') {
      $('.gift-prices input').first().prop('checked', true);
    } else {
      $('.gift-prices input[value="' + $(this).val() + '"]').prop('checked', true);
    }
  });

  $('.gift-prices input').on('change', function () {
    if ($(this).val() != $('.custom-price-gift input').val()) {
      $('.custom-price-gift input').attr('name', '').val('');
    }
  });

  if (getUrlParameter('dev')) {
    $('a[href]').each(function () {
      var cur = $(this);
      var url = cur.attr('href');
      var a = url.includes('javascript');
      var b = url.includes('#');
      if (!a && !b) {
        cur.attr('href', url + '?dev=true');
      }
    });
  }

  checkProductOptions($('.body'));

  $('body').on(
    'change',
    '.product-configure input, .product-configure select, .product-configure textarea',
    function () {
      checkProductOptions($(this));
    }
  );
  // Fancybox //
  $('[data-fancybox]').fancybox({
    mobile: {
      clickSlide: 'close',
    },
    touch: false, //------ ALWAYS ON TOP! ------//
  });
  // End fancybox //

  $('.greeting-options .option .inner a.zoom').fancybox({});

  $('.custom-select').dropdown(); //------ SEMANTIC DROPDOWN ------//

  // Scroll to div //
  $('[data-scroll]').on('click', function () {
    if ($('#letter-overview-footer').length) {
      var brandHeight = $('#letter-overview-footer').outerHeight();
    } else {
      var brandHeight = 0;
    }
    var element = $(this).data('scroll');
    var headerHeight = $('#header .header-fixed-wrap').outerHeight(); // .main-header
    $('html, body').animate(
      {
        scrollTop: $(element).offset().top - headerHeight - brandHeight - 30,
      },
      'fast'
    );
  });
  // End scroll to div //
  $(window).scroll(function () {
    if ($('#letter-overview').length) {
      var cur = $('.scroll-to-top');

      var scrollTop = $(window).scrollTop();
      var headerHeight = $('#header .header-fixed-wrap').outerHeight();
      var abcOffsetTop = $('#letter-overview').offset().top;
      var abcHeight = $('#letter-overview').outerHeight();

      var combHeight = scrollTop + headerHeight;
      var combOfset = abcOffsetTop + abcHeight;

      if (combHeight > combOfset) {
        cur.addClass('active');
        // cur.css('top', scrollTop - headerHeight - abcHeight);
      } else {
        cur.removeClass('active');
      }
    }

    if ($('#letter-overview').length) {
      var overviewHeight = $('#letter-overview-footer .letter-overview').offset().top;
      var mediaQuery = '(min-width: 992px)';

      if (window.matchMedia(mediaQuery).matches) {
        var overviewHeight = overviewHeight + 140;
      } else {
        var overviewHeight = overviewHeight + 208;
      }

      $('.brands-sec').each(function (index, item) {
        var cur = $(this);
        var letter = cur.attr('data-letter');
        var LetterHeight = $(this).outerHeight();
        var letterOffsetTop = $(this).offset().top;
        var letteroffsetHeight = letterOffsetTop + LetterHeight;

        if (letteroffsetHeight > overviewHeight && letterOffsetTop < overviewHeight) {
          $('.letter-label[data-scroll="#sec-' + letter + '"]').addClass('active');
          cur.addClass('active');
        } else {
          $('.letter-label[data-scroll="#sec-' + letter + '"]').removeClass('active');
          cur.removeClass('active');
        }
      });
    }
  });

  // Accordion //
  $('[data-sm-accordion-toggle]').on('click', function () {
    var cur = $(this);
    if (cur.closest('[data-sm-accordion-tab]').hasClass('active')) {
      cur.closest('[data-sm-accordion-tab]').removeClass('active').find('[data-sm-accordion-content]').slideUp();
    } else {
      cur
        .closest('[data-sm-accordion]')
        .find('[data-sm-accordion-tab].active')
        .removeClass('active')
        .find('[data-sm-accordion-content]')
        .slideUp();
      cur.closest('[data-sm-accordion-tab]').addClass('active').find('[data-sm-accordion-content]').slideDown();
    }
  });
  // End accordion //

  // QUICKVIEW OPEN
  $('body').on('click', '.quickview-button .show-btn', function () {
    var cur = $(this);
    var id = cur.parent().find('.open-link').attr('href');
    var url = $(this).attr('data-product-url') + '?format=json';
    cur.parent().find('.open-link').trigger('click');

    var quickviewInner = $(id).find('.product-detail');
    checkProductOptions(quickviewInner);

    if (!$(id).hasClass('quickview-loaded')) {
      $(id).find('select').dropdown();
      $(id).addClass('quickview-loaded');
      $(id).find('.quickview-images').addClass('owl-carousel').owlCarousel({
        loop: false,
        margin: 0,
        items: 1,
        mouseDrag: false,
        touchDrag: false,
      });
      if ($(window).width() < 992) {
        $(id).find('.quickview-thumbs').addClass('owl-carousel').owlCarousel({
          loop: false,
          margin: 0,
          items: 4,
          mouseDrag: false,
          touchDrag: false,
        });
      }
      if (!$(id).find('.product-option').hasClass('hidden')) {
        getActiveQuickviewVar($(id).find('select'));
      }
    }
  });
  $('.open-link[data-fancybox]').fancybox({
    autoFocus: false,
    touch: false,
  });
  $('body').on('change', '.quickview-popup select', function () {
    var cur = $(this);
    getActiveQuickviewVar(cur);
  });

  $('.quickview-popup .quickview-thumbs .thumb').on('click', function () {
    var cur = $(this);
    var imgIndex = $(this).data('index');
    console.log(cur, imgIndex);
    $(this).closest('.quickview-thumbs').find('.image-wrap.active').removeClass('active');
    $(this).find('.image-wrap').addClass('active');
    $(this)
      .closest('.images')
      .find('.quickview-images')
      .trigger('to.owl.carousel', imgIndex - 1);
    var lastActive = $(this).closest('.quickview-thumbs').find('.owl-item.active').last().find('.image-wrap');
    if (lastActive.hasClass('active')) {
      cur.closest('.quickview-thumbs').trigger('next.owl.carousel');
    }
    var firstActive = $(this).closest('.quickview-thumbs').find('.owl-item.active').first().find('.image-wrap');
    if (firstActive.hasClass('active')) {
      cur.closest('.quickview-thumbs').trigger('prev.owl.carousel');
    }
  });

  /* newsletter popup */
  if ($('#newsletter-popup')) {
    var showAfter = $('#newsletter-popup').data('show');
    var showAfter = showAfter * 1000;
    var hideFor = $('#newsletter-popup').data('hide');
    var hideFor = hideFor / 24;

    $('[data-fancybox="newsletter"]').fancybox({
      afterClose: function () {
        Cookies.set('closed', 'yes', { expires: hideFor });
      },
    });

    if (Cookies.get('closed') != 'yes' && Cookies.get('registered') != 'yes') {
      setTimeout(function () {
        $('.open-newsletter').trigger('click');
      }, showAfter);
    }

    $('.submit-newsletter').on('click', function () {
      var email = $(this).closest('form').find('input[type="email"]').val();
      var input = $(this).closest('form').find('input[type="email"]');
      var form = $(this).closest('form');
      if (!isValidEmailAddress(email)) {
        input.addClass('error');
      } else {
        Cookies.set('registered', 'yes', { expires: 365 });
        form.submit();
      }
    });

    //Cookies.set('registered', 'yes', { expires: 365 });
  }
  /* end newsletter popup */

  // Header fixed //
  // headerFixed();
  $(window).scroll(function () {
    headerFixed();
  });
  // End header fixed //

  $(window).load(function () {
    var stickyCart = $('#sticky-cart');
    var stickyCartHeight = stickyCart.outerHeight();
    $('#footer').css('margin-bottom', stickyCartHeight);
  });

  // Messages //
  setTimeout(function () {
    $('.message-wrap:not(.live-message)').removeClass('active');
  }, 6000);
  // End messages //

  // livesearch //
  // $('.search-form input').keyup(function () {
  //   liveSearch($(this));
  // });
  // $('.search-form input').bind('webkitspeechchange', function () {
  //   liveSearch($(this));
  // });
  // $('.search-autocomplete input[type="checkbox"], .search-autocomplete input[type="radio"], .search-autocomplete select'
  // ).live('change', function () {
  //   liveSearch($(this));
  // });
  // $('.search-form select').on('change', function () {
  //   var option = $(this).find('option:selected').val();
  //   $(this).closest('form').attr('action', option);
  //   liveSearch($(this).closest('form').find('input[name="search"]'));
  // });

  $(document).mouseup(function (e) {
    var form = $('#header .search-bar').find('form');
    var autocomplete = $('.search-autocomplete');
    var container = autocomplete.find('.box');
    var input = form.find('input[name="search"]');

    if (
      !container.is(e.target) &&
      container.has(e.target).length === 0 &&
      !input.is(e.target) &&
      input.has(e.target).length === 0
    ) {
      form.find('.icon-search').removeClass('hidden');
      form.find('.icon-hide-search').addClass('hidden');
      autocomplete.css('display', 'none');
      $('.search-overlay').removeClass('active');
      $('.search-bar .search-wrap').css('z-index', '0');
    }
  });
  // end livesearch //

  // TODO: Wishlist
  // $('.add-to-wishlist').live('click', function (e) {
  //   e.preventDefault();
  //   var cur = $(this);
  //   var vid = cur.data('vid');

  //   if (loggedIn) {
  //     if (cur.hasClass('in-wishlist')) {
  //       var wid = '';
  //       $.get(wishlistUrl, function (data) {
  //         var wishlist = data.wishlist;
  //         console.log(wishlist[vid]);
  //         wid = wishlist[vid].wid;
  //       }).done(function () {
  //         var url = createUrl('account/wishlistDelete/' + wid + '/');
  //         $.ajax({
  //           type: 'POST',
  //           url: url,
  //         }).done(function () {
  //           refreshWishlist();
  //         });
  //       });
  //     } else {
  //       cur.addClass('in-wishlist');
  //       var url = cur.data('url');
  //       console.log(url);
  //       $.ajax({
  //         type: 'POST',
  //         url: url,
  //       }).done(function () {
  //         refreshWishlist();
  //       });
  //     }
  //   }
  // });
  // if (shopSsl) {
  //   refreshWishlist();
  // }

  // Mobile menu //
  $('.open-menu').on('click', function () {
    $('.body-wrap, .mobile-menu, .mobile-menu-overlay').toggleClass('mobile-menu-open');
    $(this).toggleClass('active');
    $('html').toggleClass('no-scroll');
  });

  $('.mobile-menu-overlay, .mobile-menu a[data-fancybox], a.open-wishlist').on('click', function () {
    $('.body-wrap, .mobile-menu, .mobile-menu-overlay').removeClass('mobile-menu-open');
    $('.open-menu').removeClass('active');
    $('html').removeClass('no-scroll');
  });

  $('.mobile-menu ul li .more-cats').on('click', function () {
    var cur = $(this);
    if (!cur.closest('li').hasClass('active')) {
      cur.closest('ul').find('li').removeClass('active');
      cur.closest('ul').find('li ul').slideUp(200);
      cur.closest('li').addClass('active');
      cur.closest('li').find('>ul').slideDown(200);
    } else {
      cur.closest('li').removeClass('active');
      cur.closest('li').find('>ul').slideUp(200);
    }
  });
  // End mobile menu //

  // Headlines //
  // $('.headlines').on('initialized.owl.carousel', function() { $('.headlines-outer').removeClass('slider-loading');}).owlCarousel({
  // 	autoplay: true,
  //   items: 1
  // });
  // // End headlines //

  // Home Categories
  if ($(window).width() < 1200) {
    $('.home-categories .categories-slider')
      .addClass('owl-carousel')
      .owlCarousel({
        autoplay: false,
        margin: 0,
        loop: false,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
        },
      });
  }
  // End Home Categories

  // Home Products
  if ($(window).width() < 1200) {
    $('.home-products .products-slider')
      .addClass('owl-carousel')
      .owlCarousel({
        autoplay: false,
        margin: 0,
        loop: false,
        responsive: {
          0: {
            items: 2,
          },
          768: {
            items: 3,
          },
        },
      });
  }
  // End Home Products

  // Home Blog
  if ($(window).width() < 1200) {
    $('.home-blog .article-slider')
      .addClass('owl-carousel')
      .owlCarousel({
        autoplay: false,
        margin: 0,
        loop: false,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          1200: {
            items: 3,
          },
        },
      });
  }
  // End Home Blog

  // Home Instagram
  //   if($('.instagram-feed').length > 0 ){
  //     var instaPostCount = 0;
  //     var hashtag = $('.instagram-feed .instashow-gallery').data('is-source');
  //     var appendHTML = '';
  //     appendHTML += '<div class="instashow-gallery-media gallery-media-square post-0">';
  //       appendHTML += '<div class="instashow-inner">';
  //         appendHTML += '<div class="subtitle">'+ajaxTranslations('instagram-text-1']+'</div>';
  //         appendHTML += '<div class="title title-font">'+hashtag+'</div>';
  //         appendHTML += '<div class="subtitle">'+ajaxTranslations('instagram-text-2']+'<i class="bx bx-right-arrow-alt after"></i></div>';
  //       appendHTML += '</div>';
  //     appendHTML += '</div>';

  //     setTimeout(function(){
  //     $('.instagram-feed .instashow-gallery-view .instashow-gallery-media').each(function(){
  //       instaPostCount++;
  //       $(this).addClass('post-'+instaPostCount)
  //     });
  //     $(appendHTML).insertBefore('.instagram-feed .instashow-gallery-media.post-1');
  //     }, 1000);
  //   };
  // End Home Instagram

  // Products Second Image
  if ($(window).width() > 1199) {
    $('.products .product .inner').on('mouseenter', function () {
      var cur = $(this).closest('.product');
      var url = cur.data('url').replace('.html', '.ajax');

      // if (!cur.hasClass('loaded')) {
      //   $.get(url, function (product) {
      //     // console.log(product);
      //     if (product.images[1]) {
      //       cur
      //         .find('.image-wrap .sec')
      //         .append(
      //           '<img src="' +
      //             product.images[1].replace('50x50x2', '277x400x1') +
      //             '" alt="' +
      //             product.title +
      //             '" title="' +
      //             product.title +
      //             '">'
      //         );
      //       cur.addClass('has-sec');
      //     }
      //   }).done(function () {
      //     cur.addClass('loaded');
      //   });
      // }
    });
  }
  // End Products Second Image

  // Products //
  $(window).scroll(function () {
    var productIndex = 0;
    $('.products .product').each(function () {
      var cur = $(this);
      if (cur.isOnScreen()) {
        productIndex++;
        // loadProduct(cur, productIndex);
      }
    });
  });

  $('.products .product:not(.slider)').each(function (index, product) {
    var cur = $(this);
    if (cur.isOnScreen()) {
      // loadProduct(cur, index);
    }
  });

  // Collection Toggle Filters
  $('#collection .col-sidebar .filter-wrap .filter-title').on('click', function () {
    $(this).closest('.filter-wrap').toggleClass('open').find('.filter-inner').slideToggle(200);
  });
  // End Collection Toggle Filters

  // open collection sidebar
  $('#collection .open-filters').on('click', function () {
    $('.sidebar-overlay, .sidebar').addClass('active');
    $('html, body').addClass('no-scroll');
  });
  // close collection sidebar
  $('.sidebar .close-filters, .sidebar-overlay').on('click', function () {
    $('.sidebar-overlay, .sidebar').removeClass('active');
    $('html, body').removeClass('no-scroll');
  });

  // Productpage //
  $('.productpage-slider')
    .on('initialized.owl.carousel', function () {
      $('.productpage-slider-outer').removeClass('slider-loading');
    })
    .owlCarousel({
      margin: 0,
      autoplay: false,
      items: 1,
      loop: true,
    });

  $('.productpage-slider-gift')
    .on('initialized.owl.carousel', function () {
      $('.productpage-slider-outer').removeClass('slider-loading');
    })
    .owlCarousel({
      margin: 0,
      autoplay: false,
      items: 1,
      loop: true,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      freeDrag: false,
    });
  if (template != 'pages/collection.rain') {
    $('.thumbs .thumb').on('click', function () {
      var imageIndex = $(this).data('index');
      $('.productpage-slider, .productpage-slider-gift').trigger('to.owl.carousel', imageIndex);
      $('#productpage .thumbs .thumb').removeClass('active');
      $(this).addClass('active');
    });

    $('.productpage-slider').on('translated.owl.carousel', function (event) {
      var imageIndex = $(this).find('.owl-item.active .image-wrap').data('index');
      $('#productpage .thumbs .thumb').removeClass('active');
      $('.thumb[data-index="' + imageIndex + '"]').addClass('active');
    });
  }
  // Bundles Slider
  $('.bundles-slider').addClass('owl-carousel').owlCarousel({
    margin: 0,
    autoplay: false,
    items: 1,
    loop: false,
    dots: true,
  });
  // Related Products Slider
  $('.related-slider').owlCarousel({
    margin: 0,
    autoplay: false,
    loop: false,
    responsive: {
      0: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  });
  // Sticky cart mobile
  if ($(window).width() < 768) {
    if ($('header .sticky-product').length > 0) {
      $(window).scroll(function () {
        var scrollTop = $(window).scrollTop();
        var cartOffsetTop = $('#productpage .product-info .cart .add-cart').offset().top;

        if (scrollTop >= cartOffsetTop) {
          $('header .sticky-product').addClass('active').show(500);
        } else {
          $('header .sticky-product').removeClass('active').hide(500);
        }
      });
    }
  }
  // Upsell popup slider
  $('.upsell-products-slider').owlCarousel({
    autoplay: false,
    nav: false,
    loop: false,
    responsive: {
      0: {
        items: 2,
      },
      767: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
  // Thumbs responsive
  if ($(window).width() < 992) {
    $('.productpage-thumbs:not(.giftcard-thumbs)').addClass('owl-carousel');
    $('.productpage-thumbs:not(.giftcard-thumbs)')
      .on('initialized.owl.carousel', function () {
        $('.thumbs-wrap-outer').removeClass('slider-loading');
      })
      .owlCarousel({
        loop: false,
        items: 5,
        responsive: {
          0: {
            items: 5,
          },
          992: {
            items: 5,
          },
        },
      });
  }

  $('.productpage-giftcard-thumbs')
    .on('initialized.owl.carousel', function () {
      $('.thumbs-wrap-outer').removeClass('slider-loading');
    })
    .owlCarousel({
      loop: false,
      items: 3,
      responsive: {
        0: {
          items: 3,
        },
        992: {
          items: 3,
        },
      },
    });

  $(document).ready(function () {
    function setActiveImage() {
      let activeImageIndex = $('.productpage-slider a[data-image="active"]').parent().index();

      if (activeImageIndex !== -1) {
        $('.productpage-slider').trigger('to.owl.carousel', [activeImageIndex]);
      }

      setTimeout(() => {
        $('.productpage-slider').closest('.product-images').removeClass('onload');
        $('.giftcard__thumbs').removeClass('onload');
      }, 500);
    }

    // Run on page load
    setActiveImage();
  });

  // End productpage //

  // Blog //
  // $('.regular-articles .blog-articles').masonry({
  // 	horizontalOrder: true
  // });
  // End blog //

  // Live cart //
  // $('body').on('click', '.add-live', async function (e) {
  //   var cur = $(this);
  //   cur.addClass('disabled');

  //   var form = $(this).closest('form');
  //   var quantity = 1;

  //   if (cur.hasClass('productpage')) {
  //     var url = form.attr('action');
  //     quantity = form.find('[name="quantity"]').val();
  //   } else {
  //     var url = $(this).data('url');
  //   }

  //   var btn = $(this);
  //   var btnText = $(this).html();

  //   btn.html('<i class="fa fa-circle-o-notch fa-spin"></i>');

  //   if ($(this).hasClass('add-live')) {
  //     var type = 'add';
  //   } else {
  //     var type = '';
  //   }

  //   console.log(form, url, type);

  //   if ($(this).hasClass('has-options')) {
  //     var vid = $(this).data('vid');
  //     var custId = $(this).closest('.custom-options');
  //     console.log('test');
  //     // var url = createUrl('cart/add/'+vid+/'')
  //   }

  //   if ($(this).hasClass('productpage')) {
  //     if ($(this).hasClass('upsell-submit')) {
  //       $('.ca-products .ca-products-item').each(async function () {
  //         const productId = $(this).data('product-id');
  //         const input = $(this).find('.upsell-quantity-input');
  //         const quantity = input.val();

  //         if (Number(quantity)) {
  //           const url = `${basicUrl}cart/add/${productId}?quantity=${quantity}`;
  //           setTimeout(() => {
  //             fetch(url, {
  //               method: 'POST',
  //             });
  //           }, 200);
  //         }
  //       });
  //     }

  //     var upsell_items = [];
  //     $('[name="upsell_products[]"]:checked').each(function () {
  //       var id = $(this).val();
  //       upsell_items.push({
  //         id: id,
  //         quantity: 1,
  //       });
  //     });

  //     await addToCartInBulk(upsell_items);
  //     $.ajax({
  //       type: 'POST',
  //       data: form.serialize(),
  //       url: url,
  //     }).done(function (data) {
  //       // console.log(data);
  //       btn.html(btnText);
  //       if ($('.open-upsell').length && !cur.hasClass('add-bulk')) {
  //         $('.open-upsell').trigger('click');
  //       }
  //       if ($(window).width() < 768 || dev) {
  //         createMessage(data);
  //       }
  //       updateCart(btn, btnText, type);
  //       // createMessage(data);
  //       //toGoPrice();
  //     });
  //   } else {
  //     $.ajax({
  //       type: 'POST',
  //       url: url,
  //     }).done(function (data) {
  //       updateCart(btn, btnText, type);
  //       createMessage(data);
  //       if (template == 'pages/cart.rain') {
  //         window.location.reload();
  //       }
  //     });
  //   }

  //   return false;
  // });

  // function getFormData($form) {
  //   var unindexed_array = $form.serializeArray();
  //   var indexed_array = {};

  //   $.map(unindexed_array, function (n, i) {
  //     indexed_array[n['name']] = n['value'];
  //   });

  //   return indexed_array;
  // }

  $('body').on('click', '.live-delete', function () {
    const form = $(this).closest('form');
    console.log(form);
    const line = $(this).closest('.cart-product');
    console.log(line);

    $(line).find('input[name="updates[]"]').val(0);

    $.ajax({
      type: 'post',
      url: form.attr('action'),
      data: form.serialize(),
    }).done((data) => {
      updateCart('', '', 'delete');
    });
  });

  // START account

  // account dashboard

  $('.return-dropdown select').on('change', function () {
    var selected = $(this).find('option:selected').val();
    console.log(selected);
    var cur = $(this);
    if (selected == 'specify') {
      cur.closest('.input').next('.specify').removeClass('hidden');
    } else {
      cur.closest('.input').next('.specify').addClass('hidden');
    }
  });

  $('.chat-box-outer').scroll();
  var height = $('.chat-box-outer').innerHeight();
  $('.chat-box-outer').animate(
    {
      scrollTop: 50000,
    },
    0
  );

  setInterval(function () {
    refreshChats();
  }, 5000);

  // $('#ticketForm').on('submit', function (e) {
  //   e.preventDefault();
  //   var url = $(this).attr('action');
  //   var form = $(this);

  //   $.ajax({
  //     type: 'POST',
  //     url: url,
  //     data: form.serialize(),
  //   }).done(function () {
  //     refreshChats();
  //     form.find('input[type="text"]').val('');
  //   });
  // });

  // $('select[name="type"]').on('change', function () {
  //   var type = $(this).find('option:selected').val();
  //   if (type == 'company') {
  //     $('#account-dashboard').find('.company-info').removeClass('hidden');
  //   } else {
  //     $('#account-dashboard').find('.company-info').addClass('hidden');
  //   }
  // });
  // $('#account-dashboard [name="password_change"]').on('change', function () {
  //   var checked = $(this).prop('checked');
  //   if (checked) {
  //     $('#account-dashboard').find('.change-password').removeClass('hidden');
  //   } else {
  //     $('#account-dashboard').find('.change-password').addClass('hidden');
  //   }
  // });

  // if ($('.recent-orders.dash').length > 0) {
  //   var ordersUrl = createUrl('account/orders') + '?format=json';
  //   ordersUrl = ordersUrl.replace('http:', 'https:');
  //   $.get(ordersUrl, function (data) {
  //     if (data.orders.items) {
  //       $('.recent-orders').empty();
  //       var orderIndex = 0;
  //       $.each(data.orders.items, function (index, order) {
  //         orderIndex++;
  //         var status = '';
  //         if (
  //           order.status == ajaxTranslations('Awaiting payment') ||
  //           order.status == ajaxTranslations('Awaiting pickup') ||
  //           order.status == ajaxTranslations('Awaiting shipment')
  //         ) {
  //           status = 'warning';
  //         } else if (order.status == ajaxTranslations('Cancelled')) {
  //           status = 'error';
  //         } else if (order.status == ajaxTranslations('Picked up') || order.status == ajaxTranslations('Shipped')) {
  //           status = 'success';
  //         }

  //         var html = '';
  //         html += '<div class="recent-order">';
  //         html += '<div class="inner">';
  //         html += '<div class="col">';
  //         html += '<div class="order-label">' + ajaxTranslations('Order') + '</div>';
  //         html += '<div class="title title-font">' + order.number + '</div>';
  //         html += '</div>';
  //         html += '<div class="col hidden-xs">';
  //         html += '<div class="order-label">' + ajaxTranslations('Date') + '</div>';
  //         html += '<div class="title title-font">' + moment(order.date).format('DD-MM-Y') + '</div>';
  //         html += '</div>';
  //         html += '<div class="col">';
  //         html += '<div class="order-label">' + ajaxTranslations('Total') + '</div>';
  //         html += '<div class="title title-font">' + money(order.price) + '</div>';
  //         html += '</div>';
  //         html += '<div class="col hidden-xs">';
  //         html += '<div class="order-label">' + ajaxTranslations('Status') + '</div>';
  //         html += '<div class="status-label ' + status + '">' + order.status + '</div>';
  //         html += '</div>';
  //         html += '<div class="col">';
  //         html +=
  //           '<a class="btn accent" href="' +
  //           createUrl('account/ordersView/' + order.id) +
  //           '"><i class="fa fa-angle-right"></i></a>';
  //         html += '</div>';
  //         html += '</div>';
  //         html += '</div>';
  //         if (orderIndex < 3) {
  //           $('.recent-orders').append(html);
  //         }
  //       });

  //       $('[data-order-q]').html('(' + orderIndex + ')');
  //     } else {
  //       $('<div class="">' + ajaxTranslations('No orders found') + '...</div>').insertBefore('.recent-orders');
  //     }
  //   });
  // }

  //wishEventListener();
}); // End document ready

$(window).load(function () {
  sizing();
  if (window.location.hash) {
    var href = window.location.hash;
    if (href.indexOf('#') != -1) {
      var headerHeight = $('.header-fixed-wrap').outerHeight();
      $('html, body').animate(
        {
          scrollTop: $(href).offset().top - headerHeight - 30,
        },
        500
      );
    }
  }
});
$(window).resize(function () {
  sizing();
});

function createUrl(url) {
  url = basicUrl + url;
  return url;
}

function createUrlAssets(url) {
  url = assetsUrl + url;
  return url;
}

function createImage(id, format) {
  var imageUrl =
    '//static.webshopapp.com/shops/' + pad(shopId, 6) + '/files/' + pad(id, 9) + '/' + format + '/image.jpg';
  return imageUrl;
}

function sizing() {
  headerFixed();
  // Topbar USP slider //
  if ($(window).width() < 1400) {
    $('#header .usp-bar .usp-slider').addClass('owl-carousel');
    $('#header .usp-bar .usp-slider')
      .on('initialized.owl.carousel', function () {
        $('.usp-slider-wrap').removeClass('slider-loading');
      })
      .owlCarousel({
        loop: true,
        autoplay: true,
        nav: false,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          1200: {
            items: 3,
          },
        },
      });
  } else {
    $('#header .usp-bar .usp-slider')
      .trigger('destroy.owl.carousel')
      .removeClass('owl-carousel')
      .addClass('mobile-hidden');
  }
  // End topbar USP slider //
}

function pad(str, max) {
  str = str.toString();
  return str.length < max ? pad('0' + str, max) : str;
}

function updateQuantity(way, cur) {
  var quantity = parseInt(cur.closest('.input-wrap').find('input').val());

  if (way == 'up') {
    quantity++;
  } else {
    if (quantity > 1) {
      quantity--;
    }
  }

  cur.closest('.input-wrap').find('input').val(quantity);
}

function money(price) {
  if (price) {
    price = parseFloat(price).toFixed(2);
    price += '';
    // var shopCurrency = '';
    var x = price.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    var x3 = (x1 + x2).split('.');
    var x4 = x3[0].replace(',', '.') + ',' + x3[1];
    if ((priceStatus == 'login' && !loggedIn) || !priceStatus) {
      var priceMoney = shopCurrency + '--,--';
    } else {
      var priceMoney = shopCurrency + '' + x4;
    }
    if (shopCurrency == '$') {
      priceMoney = priceMoney.replace(',', '.');
    }
  } else {
    var priceMoney = '';
  }
  return priceMoney;
}

// function compare() {
//   $.get(compareUrl, function (data) {
//     var products = data.page.compare;
//     var compareIds = [];

//     if (products) {
//       products = products.reverse();
//     }

//     $('.compare-products').empty();

//     if (products) {
//       $('.compare-pop').addClass('active');
//       $('[data-compare-items]').html(products.length);
//     } else {
//       $('.compare-pop').removeClass('active').removeClass('open');
//       $('.compare-overlay').removeClass('active');
//       $('[data-compare-items]').html(0);
//     }

//     if (products) {
//       $.each(products, function (index, product) {
//         var html = '';
//         compareIds.push(product.id);
//         html += '<div class="compare-product">';
//         html += '<div class="inner">';
//         html += '<div class="image">';
//         html += '<img src="' + createImage(product.image, '138x200x1') + '">';
//         html += '</div>';
//         html += '<div class="info">';
//         if (product.brand) {
//           html += '<div class="product-brand">' + product.brand.title + '</div>';
//         }
//         html +=
//           '<a href="' +
//           createUrl(product.url) +
//           '" title="' +
//           product.fulltitle +
//           '" class="title title-font">' +
//           product.title +
//           '</a>';

//         html += '<div class="stars-price">';
//         html += '<div class="price">';
//         html += '<div class="new-price">' + money(product.price.price) + '</div>';
//         html += '</div>';
//         html += '</div>';
//         html += '</div>';
//         html += '<div class="delete">';
//         html +=
//           '<a class="delete-compare" data-del-url="' +
//           createUrl('compare/delete/' + product.vid) +
//           '" href="javascript:;"><i class="fa fa-times"></i></a>';
//         html += '</div>';
//         html += '</div>';
//         html += '</div>';

//         $('.compare-products').prepend(html);
//       });
//     }

//     $('.compare-check').each(function () {
//       var curId = $(this).attr('data-id');
//       curId = parseFloat(curId);
//       var cur = $(this);

//       if ($.inArray(curId, compareIds) > -1) {
//         cur.prop('checked', 'checked');
//       } else {
//         cur.removeAttr('checked');
//       }
//     });
//   });
// }

var infiniteCollectionPageAvailable = false;
var infiniteCollectionPageManual = false;
var infiniteCollectionPage = 1;
var infiniteCollectionBusy = false;
var infiniteCollectionRemaining = 0;
function infiniteCollectionInit(url, page, mode) {
  infiniteCollectionPageAvailable = true;

  $('.blog-spinner-more').click(function () {
    infiniteCollectionLoad(url, mode, 'click');
    return false;
  });

  $('.blog-spinner-more').click(function () {
    infiniteBlogLoad(url, mode);
    return false;
  });

  var currentUrl = window.location.href;
  var scrolledPage = currentUrl.split('#');
  scrolledPage = scrolledPage[1] ? scrolledPage[1] : false;
  if (scrolledPage) {
    infiniteCollectionLoad(url, mode, 'pageload');
  }

  // infiniteBlogLoad(url, mode);
  $(document).scroll(function () {
    if (infiniteCollectionPageAvailable && !infiniteCollectionPageManual) {
      if (page == 'blog') {
        var offsetFromScreen = $(window).height() + $(window).scrollTop() - $('.blog-spinner').offset().top;

        if (offsetFromScreen > 0) {
          infiniteBlogLoad(url, mode);
        }
      } else {
        if ($('.collection-spinner').length > 0) {
          var offsetFromScreen = $(window).height() + $(window).scrollTop() - $('.collection-spinner').offset().top;
          if (offsetFromScreen > 0) {
            infiniteCollectionLoad(url, mode, false);
          }
        }
      }
    }
  });
  $(document).scroll();
}

function infiniteBlogLoad(url, mode) {
  if (!infiniteCollectionBusy) {
    infiniteCollectionBusy = true;
    $('.blog-spinner').addClass('busy');
    infiniteCollectionPage++;
    url = url.replace('page1.ajax', 'page' + infiniteCollectionPage + '.html?format=json');
    $.getJSON(url, function (json) {
      if (json.blog.articles) {
        infiniteCollectionRemaining = 5 - json.blog.pagination.page * 5;

        if (infiniteCollectionRemaining < 5) {
          $('.blog-spinner-more span').text(infiniteCollectionRemaining);
        }

        if (json.blog.pagination.pages <= infiniteCollectionPage) {
          infiniteCollectionPageAvailable = false;
          $('.blog-spinner').remove();
        }

        if (infiniteCollectionPage > 100) {
          infiniteCollectionPageManual = true;
          $('.blog-spinner').addClass('manual');
        }

        var counter = 1;

        var sortArticles = {};
        var count = 1;

        $.each(json.blog.articles, function (index, article) {
          var thisDate = Date.parse(article.date);
          sortArticles[thisDate] = article;
        });

        //         var articles = {};
        //         var number = 5;

        //         $.each(sortArticles, function(index, article){
        //           articles[number--] = article;
        //         });

        $.each(sortArticles, function (index, article) {
          var container = $('.blog-articles.inf-articles');
          var blogCol = container.data('blogcol');
          var html = '';

          var summary = article.summary;
          if (summary.length > 200) {
            summary = summary.substring(0, 200) + '... ';
          }

          html += '<div class="blog-article ' + blogCol + '">';
          html += '<div class="inner">';
          html += '<a class="image-wrap" href="' + createUrl(article.url) + '">';
          html +=
            '<div class="image" style="background: url(' +
            createImage(article.image) +
            ') #f7f7f7 no-repeat center center; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;"></div>';
          html += '</a>';
          html += '<div class="info">';

          html += '<div class="date-author">';
          html +=
            '<div class="date">' +
            moment(article.date).format('D') +
            ' ' +
            ajaxTranslations(moment(article.date).format('MMMM')) +
            '</div>';
          html += '</div>';

          html += '<a href="' + createUrl(article.url) + '" class="title title-font">' + article.title + '</a>';

          html += '<div class="summary">';
          html += '<span class="content hidden-xs">';
          html += summary;
          html += '</span>';
          html +=
            '<a class="read-more" href="' + createUrl(article.url) + '">' + ajaxTranslations('Read more') + '</a>';
          html += '</div>';
          html += '</div>';

          html += '</div>';
          html += '</div>';

          //container.append(html);
          var $html = $(html);
          container.append($html).masonry('appended', $html);

          counter++;
        });
      }

      infiniteCollectionBusy = false;
      $('.collection-spinner').removeClass('busy');

      $(document).scroll();
    });
  }
}

function createMessage(data) {
  var messages = $(data).find('div[class="gui-messages"] ul');
  var message = messages.first('li').text();
  var messageType = false;
  var icon = '';

  if (!message) {
    message = false;
  }

  if (messages.hasClass('error') || messages.hasClass('gui-error')) {
    messageType = 'error';
    icon = 'fa-times';
  } else if (messages.hasClass('success') || messages.hasClass('gui-success')) {
    messageType = 'success';
    icon = 'fa-check';
  } else if (messages.hasClass('info') || messages.hasClass('gui-info')) {
    messageType = 'info';
    icon = 'fa-info';
  }

  if (message) {
    $('.live-message .message').removeClass('error succes info').addClass(messageType);
    $('.live-message .message .icon i').removeClass('fa-info fa-check fa-times');
    $('.live-message').addClass('active');
    $('.live-message .message .text ul li').html(message);
    $('.live-message .message .icon i').addClass(icon);

    setTimeout(function () {
      $('.live-message').removeClass('active');
    }, 4000);
  }
}

function urlencode(str) {
  return encodeURIComponent(str)
    .replace(/!/g, '%21')
    .replace(/'/g, '%27')
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29')
    .replace(/\*/g, '%2A')
    .replace(/%20/g, '+');
}

function liveSearch(cur) {
  var form = cur.closest('form');
  var type = form.data('search-type');
  var autocomplete = $('.search-autocomplete[data-search-type="' + type + '"]');
  var input = $('[data-input=' + type + ']');
  var url = $('form[data-search-type="' + type + '"]').attr('action');
  if ($(window).width() > 767) {
    var productLimit = 6;
  } else {
    var productLimit = 3;
  }
  var query = input.val();
  $('[data-search-query]').html(query);
  query = urlencode(query.replace('/', '-slash-'));

  //var form = $('.search-autocomplete form');
  var selectedFilters = form.serialize();

  if (query.length > 2) {
    form.find('.icon-search').addClass('hidden');
    form.find('.icon-hide-search').removeClass('hidden');

    var foundCategories = {};

    $.each(shopCategories, function (index, category) {
      var searchCat = query.toLowerCase().replace(' ', '').replace('+', '');
      var findCat = category.title.toLowerCase().replace(' ', '');
      searchCat = searchCat.replace(new RegExp('\\+', 'g'), '');
      findCat = findCat.replace(/ /g, '');

      if (findCat.indexOf(searchCat) >= 0) {
        foundCategories[category.id] = { title: category.title, url: category.url };
      }
      if (category.subs) {
        var cat_up = shopCategories[category.id];
        $.each(category.subs, function (index, category) {
          var findCat = category.title.toLowerCase().replace(' ', '');
          findCat = findCat.replace(/ /g, '');

          if (findCat.indexOf(searchCat) >= 0) {
            foundCategories[category.id] = { title: category.title, url: category.url, path: cat_up['title'] };
          }

          if (category.subs) {
            var newCatUp = cat_up['title'] + ' / ' + category.title;
            $.each(category.subs, function (index, category) {
              var findCat = category.title.toLowerCase().replace(' ', '');
              findCat = findCat.replace(/ /g, '');
              if (findCat.indexOf(searchCat) >= 0) {
                foundCategories[category.id] = { title: category.title, url: category.url, path: newCatUp };
              }
            });
          }
        });
      }
    });

    autocomplete.find('.feat-categories .cats ul').empty();
    var loopIndex = 0;
    var catLimit = 8;
    if ($(window).width() < 992) {
      catLimit = 6;
    }
    $.each(foundCategories, function (index, category) {
      loopIndex++;
      if (loopIndex <= catLimit) {
        $('.search-autocomplete .feat-categories .cats ul').append(
          '<li><a href="' + createUrl(category.url) + '">' + category.title + '</a></li>'
        );
      }
    });
    if (loopIndex == 0) {
      autocomplete.find('.feat-categories').addClass('hidden');
    } else {
      autocomplete.find('.feat-categories').removeClass('hidden');
    }

    var jsonUrl = url + '?limit=' + productLimit + '&' + selectedFilters + '&format=json';
    var ajaxUrl = url + 'page1.ajax?limit=' + productLimit + '&' + selectedFilters + '&' + 'search=' + query;

    $.get(ajaxUrl, function (json) {
      //console.log(ajaxUrl);
      var productsHtml = [];
      $.each(json.products, function (index, product) {
        var productHtml = '';

        productHtml += '<div class="product col-md-4">';
        productHtml += '<div class="product-inner">';
        productHtml += '<div class="image-wrap">';
        productHtml += '<a href="' + product.url + '">';
        productHtml +=
          '<img src="' + product.image.replace('50x50x2', '100x100x2') + '" alt="MVTM Gunmetal Sandstone">';
        productHtml += '</a>';
        productHtml += '</div>';
        productHtml += '<div class="info">';
        // if (product.brand) {
        //   productHtml += '<div class="brand">'+product.brand.title+'</div>';
        // }
        var productTitlte = product.fulltitle.replace(/([|])/g, '');
        productHtml += '<a class="title" href="' + product.url + '">' + productTitlte + '</a>';
        productHtml += '<div class="price">' + money(product.price.price) + '</div>';
        productHtml += '</div>';
        productHtml += '</div>';
        productHtml += '</div>';

        productsHtml.push(productHtml);
      });

      productsHtml = productsHtml.join('');

      autocomplete.find('.search-products').empty();
      autocomplete.find('.search-products').html(productsHtml);
    });

    $.getJSON(jsonUrl, function (json) {
      var collection = json.collection;

      autocomplete.find('.custom-filters').empty();
      if (collection.brands) {
        var html = '';
        html += '<div class="filter-wrap">';
        html += '<div class="filter-title title-font">' + ajaxTranslations('Brands') + '</div>';
        html += '<div class="filter-items">';
        $.each(collection.brands, function (index, value) {
          if (value.id == collection.brand2.id) {
            var valueActive = 'checked="checked"';
          } else {
            var valueActive = '';
          }
          html += '<div class="ui checkbox filter-item">';
          html +=
            '<input id="filter_' +
            value.id +
            '" type="radio" name="brand" value="' +
            value.id +
            '" ' +
            valueActive +
            ' />';
          html += '<label for="filter_' + value.id + '">' + value.title + '';
          if (!value.active && value.has_count) {
            html += '<span>(' + value.count + ')</span>';
          }
          html += '</label>';
          html += '</div>';
        });
        html += '</div>';
        html += '</div>';
        autocomplete.find('.custom-filters').append(html);
      }
      if (collection.filters.custom) {
        $.each(collection.filters.custom, function (index, filter) {
          var html = '';

          html += '<div class="filter-wrap">';
          html += '<div class="filter-title title-font">' + filter.title + '</div>';
          html += '<div class="filter-items">';
          $.each(filter.values, function (index, value) {
            if (value.active) {
              var valueActive = 'checked="checked"';
            } else {
              var valueActive = '';
            }
            html += '<div class="ui checkbox filter-item">';
            html +=
              '<input id="filter_' +
              value.id +
              '" type="checkbox" name="filter[]" value="' +
              value.id +
              '" ' +
              valueActive +
              ' />';
            html += '<label for="filter_' + value.id + '">' + value.title + '';
            if (!value.active && value.has_count) {
              html += '<span>(' + value.count + ')</span>';
            }
            html += '</label>';
            html += '</div>';
          });
          html += '</div>';
          html += '</div>';

          autocomplete.find('.custom-filters').append(html);
        });
      }
      autocomplete.find('.side .sort select').empty();
      if (collection.sorts) {
        $.each(collection.sorts, function (index, sort) {
          var html = '';
          if (collection.filters.sort == sort.id) {
            $('.search-autocomplete .side .sort .dropdown .text').html(sort.title);
            var selected = ' selected="selected"';
          } else {
            var selected = '';
          }
          html += '<option value="' + sort.id + '" ' + selected + '>' + sort.title + '</option>';
          $('.search-autocomplete .side .sort select').append(html);
        });
      }

      if (collection.count > 0) {
        autocomplete.find('.more a').attr('href', createUrl(collection.internal.url + '?' + selectedFilters));
        autocomplete.find('.more span').html('(' + collection.count + ')');
        autocomplete.removeClass('noresults');
      } else {
        $('.search-autocomplete').addClass('noresults');
      }
      autocomplete.css('display', 'block');
      $('.search-overlay').addClass('active');
      $('.search-bar .search-wrap').css('z-index', '99999');
      form.find('input[name="search"]').addClass('mobile-active');
    });
  } else {
    form.find('.icon-search').removeClass('hidden');
    form.find('.icon-hide-search').addClass('hidden');
    autocomplete.css('display', 'none');
    $('.search-overlay').removeClass('active');
    $('.search-bar .search-wrap').css('z-index', '0');
    form.find('input[name="search"]').removeClass('mobile-active');
  }
}

// function updateCart(btn, btnText, type) {
//   if (btn) {
//     if (!btn.hasClass('in-sticky-cart') && !btn.hasClass('small-btn') && btn.hasClass('productpage')) {
//       btn.html('<i class="bx bx-check"></i>' + ajaxTranslations('Added') + '');
//     } else {
//       btn.html('<i class="bx bx-check"></i>');
//     }

//     btn.removeClass('disabled');

//     setTimeout(function () {
//       btn.html(btnText);
//     }, 2000);
//   }

//   $.get(window.location.href, function (data) {
//     const html = $.parseHTML(data);
//     const cartDropdown = $(html).find('.cart-dropdown');
//     const cartQ = $(html).find('.header-icons .cart a[href="/cart"]');

//     $('.cart-dropdown').html(cartDropdown.html());
//     $('.header-icons .cart a[href="/cart"]').html(cartQ.html());

//     if (type == 'add' && $(window).width() < 768) {
//       var cart = $('#header .main-header li.cart');
//       if (btn.closest('.product').length > 0) {
//         var imgtodrag = btn.closest('.product').find('.image-wrap img').eq(0);
//       } else {
//         var imgtodrag = $('.productpage-slider .owl-item.active img');
//       }
//     }

//     if (type == 'add') {
//       $('.cart-dropdown').addClass('active');
//       $('#header .main-header .header-icons > li.cart').addClass('wiggle');
//       setTimeout(function () {
//         $('.cart-dropdown').removeClass('active');
//         $('#header .main-header .header-icons > li.cart').removeClass('wiggle');
//       }, 4000);
//     }
//   }).done(function () {});
// } // end

function updateCart(btn, btnText, type) {
  if (btn) {
    if (
      !btn.classList.contains('in-sticky-cart') &&
      !btn.classList.contains('small-btn') &&
      btn.classList.contains('productpage')
    ) {
      btn.innerHTML = '<i class="bx bx-check"></i>' + ajaxTranslations('Added');
    } else {
      btn.innerHTML = '<i class="bx bx-check"></i>';
    }

    btn.classList.remove('disabled');

    setTimeout(function () {
      btn.innerHTML = btnText;
    }, 2000);
  }

  fetch(window.location.href)
    .then((response) => response.text())
    .then((data) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');

      if (template === 'cart') {
        const cart = doc.querySelector('#cart-page');
        document.querySelector('#cart-page').innerHTML = cart.innerHTML;
      }

      const cartDropdown = doc.querySelector('.cart-dropdown');
      const cartQ = doc.querySelector('.header-icons .cart a[href="' + window.Shopify.routes.root + 'cart"]');

      document.querySelector('.cart-dropdown').innerHTML = cartDropdown.innerHTML;
      document.querySelector('.header-icons .cart a[href="' + window.Shopify.routes.root + 'cart"]').innerHTML =
        cartQ.innerHTML;

      if (type === 'add' && window.innerWidth < 768) {
        const cart = document.querySelector('#header .main-header li.cart');
        let imgtodrag;

        if (btn.closest('.product')) {
          imgtodrag = btn.closest('.product').querySelector('.image-wrap img');
        } else {
          imgtodrag = document.querySelector('.productpage-slider .owl-item.active img');
        }
      }

      if (type === 'add' && template !== 'cart') {
        document.querySelector('.cart-dropdown').classList.add('active');
        document.querySelector('#header .main-header .header-icons > li.cart').classList.add('wiggle');

        setTimeout(function () {
          document.querySelector('.cart-dropdown').classList.remove('active');
          document.querySelector('#header .main-header .header-icons > li.cart').classList.remove('wiggle');
        }, 4000);
      }
    })
    .catch((error) => console.error('Error updating cart:', error));
}

function isValidEmailAddress(emailAddress) {
  var pattern =
    /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  return pattern.test(emailAddress);
}

function updateQuantity(way, cur) {
  var quantity = parseInt(cur.closest('.input-wrap').find('input').val());

  if (way == 'up') {
    quantity++;
  } else {
    if (quantity > 1) {
      quantity--;
    }
  }

  cur.closest('.input-wrap').find('input').val(quantity);
}

function infiniteCollectionLoad(url, mode, type) {
  if (!infiniteCollectionBusy) {
    var currentUrl = window.location.href;
    var scrolledPage = currentUrl.split('#');
    scrolledPage = scrolledPage[1] ? scrolledPage[1] : false;

    if (type == 'click' || !type) {
      infiniteCollectionBusy = true;
      $('.collection-spinner').addClass('busy');
      infiniteCollectionPage++;
      if (infiniteCollectionPage <= infiniteCollectionMax) {
        loadInfinitePage(url, type, infiniteCollectionPage);
      }
    }
    if (type == 'pageload' && scrolledPage) {
      infiniteCollectionBusy = true;
      $('.collection-spinner').addClass('busy');

      for (i = 1; i < scrolledPage; i++) {
        infiniteCollectionPage++;
        loadInfinitePage(url, type, infiniteCollectionPage);
      }
    }
  }
}

function loadInfinitePage(url, type, infiniteCollectionPage) {
  url = url.replace('page1.ajax', 'page' + infiniteCollectionPage + '.ajax');

  $.getJSON(url, function (json) {
    if (json.products) {
      var infiniteCollectionViewed = json.page * json.limit;
      var infiniteCollectionTotal = $('#collection').attr('data-total-products');
      infiniteCollectionTotal = parseFloat(infiniteCollectionTotal);
      var percentage = (infiniteCollectionViewed / infiniteCollectionTotal) * 100;

      $('.collection-spinner .status .bar').css('width', percentage + '%');

      //Push page number in url and set scroll position in history
      if (type == 'click') {
        history.pushState(
          {
            scroll: $(window).scrollTop(),
          },
          '',
          '#' + json.page
        );
      }

      $('#collection').attr('data-loaded-till', json.page);
      $('.collection-viewed-count span.viewed').text(infiniteCollectionViewed);

      if (json.pages <= infiniteCollectionPage) {
        infiniteCollectionPageAvailable = false;
        $('.collection-spinner').remove();
      }

      if (infiniteCollectionPage > 100) {
        infiniteCollectionPageManual = true;
        $('.collection-spinner').addClass('manual');
      }

      var counter = 1;
      $.each(json.products, function (index, product) {
        var infiniteUrl = product.url + '?format=json';
        var wishlistUrl = basicUrl + 'account/wishlistAdd/' + product.id + '/?variant_id=' + product.vid;
        var cartUrl = basicUrl + 'cart/add/' + product.vid + '/';
        var productType = $('.products').find('.product').first().data('product-type');

        var productTitle = product.fulltitle;

        if (product.image) {
          var imageUrl = product.image.replace('50x50x2', '435x650x1');
        } else {
          var imageUrl = 'http://via.placeholder.com/435x650/ffffff/000000?text=' + imageNotFound_t + '';
        }
        var plainImage = product.image.replace('/50x50x2/', '/');

        var container = $('.products');
        var containerLoss = '.products';
        var productWrap = $('<div>')
          .append($('.products').find('.inf-product').first().clone())
          .html()
          .replace('inf_id_here', product.id)
          .replace('inf-product', 'inf-product inf-loading')
          .replace('prod-loaded', '');
        var quickviewWrap = $('<div>')
          .append($('.products').find('.quickview-popup').first().clone())
          .html()
          .replace('inf_id_here', product.id)
          .replace('quickview-loaded', '');

        container.append(productWrap);
        container.append(quickviewWrap);
        var productObject = $('.products').find('.inf-product[data-inf-id="' + product.id + '"]');
        var quickviewObject = $('.products').find('.quickview-popup[data-inf-id="' + product.id + '"]');
        quickviewObject.attr('id', product.id);
        productObject.removeClass('has-variants has-sec loaded');
        productObject.find('.product-label.new').remove();
        productObject.attr({ 'data-id': product.id, 'data-url': product.url });
        productObject.find('.variants-wrap .variants').empty();
        productObject.remove('.sec');
        productObject.find('a[data-infinite-product-url]').attr({ href: product.url, title: productTitle });
        productObject.find('[data-infinite-product-image]').attr({
          src: imageUrl,
          'data-src': imageUrl,
          srcset: imageUrl,
          'data-srcset': imageUrl,
          title: productTitle,
          alt: productTitle,
        });
        productObject
          .find('[data-infinite-product-title]')
          .attr({ href: product.url, title: productTitle })
          .html(productTitle);
        if (product.available) {
          productObject.find('[data-infinite-product-product-label]').addClass('hidden');
        } else {
          productObject.find('[data-infinite-product-product-label]').removeClass('hidden');
        }

        productObject.find('[data-infinite-quickview-button]').attr('data-product-url', product.url);
        productObject.find('[data-infinite-quickview-link]').attr('href', '#' + product.id);

        productObject.find('[data-infinite-quickview-wrap]').empty();

        productObject.find('[data-infinite-product-price-wrap]').empty();
        if (product.price.price_old) {
          productObject
            .find('[data-infinite-product-price-wrap]')
            .append('<div class="price-old">' + money(product.price.price_old) + '</div>');
        }
        productObject
          .find('[data-infinite-product-price-wrap]')
          .append('<div class="price-new">' + money(product.price.price) + '</div>');

        setTimeout(function () {
          $('.product[data-id="' + product.id + '"]').removeClass('inf-loading');
          $('.product[data-id="' + product.id + '"]')
            .find('.image-wrap .sec')
            .remove();
        }, 200);

        quickviewObject
          .find('[data-infinite-product-title]')
          .attr({ href: product.url, title: productTitle })
          .html(productTitle);

        quickviewObject.find('[data-infinite-product-price-wrap]').empty();
        if (product.price.price_old) {
          quickviewObject
            .find('[data-infinite-product-price-wrap]')
            .append('<div class="price-old">' + money(product.price.price_old) + '</div>');
        }
        quickviewObject
          .find('[data-infinite-product-price-wrap]')
          .append('<div class="price-new">' + money(product.price.price) + '</div>');
        quickviewObject.find('[data-infinite-product-description] span').html(product.description);
        quickviewObject.find('[data-infinite-product-description] a').attr('href', product.url);

        if (product.available) {
          quickviewObject
            .find('[data-infinite-cart-btn]')
            .attr('data-vid', product.vid)
            .html('<i class="bx bx-cart before hidden-xs"></i>' + ajaxTranslations('Add to cart'));
          quickviewObject.find('[data-infinite-product-form]').attr('action', cartUrl);
        } else {
          quickviewObject.find('.cart .input-wrap').remove();
          quickviewObject
            .find('[data-infinite-cart-btn]')
            .attr('href', product.url)
            .html(ajaxTranslations('View product'));
        }

        if (loggedIn) {
          quickviewObject
            .find('[data-infinite-wishlist-btn]')
            .attr({ 'data-url': wishlistUrl, 'data-id': product.id, 'data-vid': product.vid });
        } else {
          quickviewObject.find('[data-infinite-wishlist-btn]').attr('href', createUrl('account'));
        }

        var facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + product.url + '';
        quickviewObject.find('[data-inf-share] a.facebook').attr('href', facebookShareUrl);
        // var twitterShareUrl = ('https://twitter.com/home?status='+product.title+'%20-%20'+product.url+'');
        // quickviewObject.find('[data-inf-share] a.twitter').attr('href', twitterShareUrl);
        var pinterestShareUrl =
          'https://pinterest.com/pin/create/button/?url=' +
          product.url +
          '&media=' +
          imageUrl +
          '&description=' +
          product.description +
          '';
        quickviewObject.find('[data-inf-share] a.pinterest').attr('href', pinterestShareUrl);

        counter++;
      });
    }

    infiniteCollectionBusy = false;
    $('.collection-spinner').removeClass('busy');

    $(document).scroll();
  });
}

function updatePayments() {
  $('.gui-payment-methods .gui-payment-method img').each(function () {
    var cur = $(this);
    if (!cur.hasClass('updated')) {
      cur.addClass('updated');
      var paymentTitle = cur.closest('label').find('input').attr('value');

      if (paymentTitle) {
        var method = cur.closest('label').find('input').attr('value').split('|')[1];
        var re = new RegExp('_', 'g');
        var method = method.replace(re, '-');
        var provider = cur.closest('label').find('input').attr('value').split('|')[0];
        var url = createUrlAssets('payment-' + method + '.png');
        if (provider != 'paynl' && provider != 'billink') {
          cur.attr('src', url);
        }
      }
    }
  });
}

function headerFixed() {
  var header = $('#header');
  // var headerHeight = header.find('.header-fixed-wrap').outerHeight();
  if ($('.header-fixed-wrap .sticky-share').length > 0) {
    var headerHeight =
      header.find('.header-fixed-wrap').outerHeight() - header.find('.header-fixed-wrap .sticky-share').outerHeight();
  } else {
    var headerHeight =
      header.find('.header-fixed-wrap').outerHeight() - header.find('.header-fixed-wrap .sticky-product').outerHeight();
  }

  // console.log(headerHeight);
  var initiateHeight = 1;
  if ($('#header .topbar').length) {
    initiateHeight = $('#header .topbar').outerHeight();
    // } else if ($('#header .usp-bar').length) {
    //   initiateHeight = $('#header .usp-bar').outerHeight();
  }

  // var scrollTop = $(window).scrollTop();
  // if ($('html').height() > $(window).height()) {
  //   $('html, body').removeClass('no-scroll');
  //   if (scrollTop >= initiateHeight) {
  //     header.addClass('fixed');
  //     $('.main-content').css('padding-top', headerHeight);
  //   } else {
  //     header.removeClass('fixed');
  //     $('.main-content').css('padding-top', '0');
  //   }
  // } else {
  //   $('html, body').addClass('no-scroll');
  // }

  if ($('#letter-overview').length) {
    var brandsWrap = $('#letter-overview');
    var brandsWrapFooter = $('#letter-overview-footer');

    var brandHeigth = brandsWrap.offset().top;
    var screenHeight = $(window).scrollTop() + headerHeight;

    if (screenHeight >= brandHeigth) {
      brandsWrapFooter.addClass('fixed');
      brandsWrap.addClass('active');
      brandsWrapFooter.css('top', headerHeight - 41);
    } else {
      brandsWrapFooter.removeClass('fixed');
      brandsWrap.removeClass('active');
      brandsWrapFooter.css('top', '0');
    }
  }

  if ($('#productpage').length > 0) {
    var outerHeight = $('#productpage .product-info .cart .btn').outerHeight();
    var scrollTop = $(window).scrollTop() + headerHeight - outerHeight;
    var cartOffsetTop = $('#productpage .product-info .cart .btn').offset().top;

    if (scrollTop >= cartOffsetTop) {
      $('#sticky-cart').addClass('active');
    } else {
      $('#sticky-cart').removeClass('active');
    }
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

function refreshChats() {
  if ($('.chat-box-inner').length > 0) {
    var url = $('.chat-box-inner').data('url') + '?format=json';
    var currentMessages = $('.chat-box-inner').attr('data-messages');
    var newQ = 0;

    $.get(url, function (data) {
      var messages = data.ticket.messages;
      messages = messages.reverse();
      newQ = messages.length;
      $('.chat-box-inner').empty();

      $.each(messages, function (index, message) {
        var messageType = 0;
        if (message.name == data.page.account.fullname) {
          var messageType = 'sent';
        } else {
          var messageType = 'received';
        }

        var html = '';
        html += '<div class="chat-message ' + messageType + '">';
        html += '<div class="message">';
        if (data.ticket.messages[index - 1]) {
          if (data.ticket.messages[index - 1]['name'] != message.name && messageType == 'received') {
            html += '<div class="name">' + message.name + '</div>';
          }
        }
        html += '<div class="text">' + message.message + '</div></div>';
        if (data.ticket.messages[index + 1]) {
          if (data.ticket.messages[index + 1]['name'] != message.name) {
            html += '<div class="date">' + message.date + '</div>';
          }
        } else {
          html += '<div class="date">' + message.date + '</div>';
        }
        html += '</div>';
        $('.chat-box-inner').prepend(html);
      });
    }).done(function () {
      if (currentMessages != newQ) {
        $('.chat-box-outer').scroll();
        var height = $('.chat-box-outer').innerHeight();
        $('.chat-box-outer').animate(
          {
            scrollTop: 50000,
          },
          0
        );
      }
      $('.chat-box-inner').attr('data-messages', newQ);
    });
  }
}

function greeting() {
  var greetingText = $('.card-text textarea').val();
  var quantity = $('.productpage .change').find('input').val();
  var activeCardId = $('.greeting-options .option.active').attr('data-vid');
  if (activeCardId) {
    $('.card-text').removeClass('hidden');
    $('.custom-card-form textarea').val(greetingText);
    $('.custom-card-form input.quantity-card').val(quantity);
  } else {
    $('.card-text').addClass('hidden');
    $('.custom-card-form textarea').val('');
  }
}

function countWords(cur, message, maxWords) {
  // var length = message.split(\b[^\s]+\b);
  var length = message.split(' ').length;
  var carttext = cur.closest('form').find('.product-add-block-wrapper').val();
  console.log(length, message, maxWords);
  if (length > maxWords) {
    cur.addClass('error');
    cur.closest('form').find('.product-add-block-wrapper').addClass('disabled');
    cur.closest('.card-text').find('.error-msg').removeClass('hidden');
    $('.add-greeting').addClass('disabled');
  } else {
    cur.removeClass('error');
    cur.closest('form').find('.product-add-block-wrapper').removeClass('disabled');
    cur.closest('.card-text').find('.error-msg').addClass('hidden');
    $('.add-greeting').removeClass('disabled');
  }
}

function getActiveQuickviewVar(cur) {
  var url = cur.find('option:selected').attr('data-url');
  var available = cur.find('option:selected').attr('data-available');
  var priceNew = cur.find('option:selected').attr('data-price');
  var priceOld = cur.find('option:selected').attr('data-price-old');
  var stockDiv = cur.closest('.product-info').find('.stock');
  var priceDivNew = cur.closest('.product-info').find('.price .new-price');
  var priceDivOld = cur.closest('.product-info').find('.price .old-price');
  priceDivNew.html('<span class="new-price">' + priceNew + '</span>');
  priceDivOld.html('<span class="old-price"><span class="price-wrap">' + priceOld + '</span></span>');
  cur.closest('form').attr('action', url);
}

function loadProduct(cur, index) {
  var url = cur.data('url');

  if (!cur.hasClass('prod-loaded')) {
    cur.addClass('prod-loaded');
    var cats = labelCategories.split(';');
    $.get(url + '?format=json', function (product) {
      var product = product.product;
      var quickForm = cur.find('[data-infinite-quickview-form]');
      if (product.stock.available) {
        $.each(product.categories, function (index, category) {
          var categoryURL = category.url;
          if (jQuery.inArray(categoryURL, cats) !== -1) {
            cur.find('.image-wrap').append('<div class="product-label new">' + category.title + '</div>');
          }
        });
      }
      var html = '';
      if (product.stock.available) {
        var prodType = cur.find('.quickview-button').attr('data-product-type');
        var isLoggedIn = $('#header').hasClass('logged-in');

        if (product.custom) {
          html +=
            '<a class="show-btn quickbuy" href="javascript:;" data-product-url="' +
            basicUrl +
            product.url +
            '" title="open quickview" data-infinite-quickview-button><span>' +
            ajaxTranslations('Quick buy') +
            '</span> <i class="bx bx-shopping-bag"></i></a>';
          html +=
            '<a class="open-link hidden" href="#' +
            prodType +
            product.id +
            '" title="' +
            product.fulltitle +
            '" data-fancybox data-infinite-quickview-link>test</a>';
        } else {
          var actionURL = basicUrl + 'cart/add/' + product.vid;
          html +=
            '<form action="' + basicUrl + 'cart/add/' + product.vid + '" method="post" data-infinite-quickview-form>';
          html +=
            '<a class="show-btn quickbuy add-cart add-live productpage" href="javascript:;" title="addCart"><span>' +
            ajaxTranslations('Quick buy') +
            '</span> <i class="bx bx-shopping-bag"></i></a>';
          if (isLoggedIn) {
            // html += '<a class="btn wishlist-btn add-to-wishlist test11" href="javascript:;" data-url="'+ basicUrl + 'account/wishlistAdd/' + product.id + '?variant_id=' + product.vid + '" title="Wishlist" data-id="'+ product.id + '" data-vid="' + product.vid + '" ><i class="bx bx-heart"></i></a>';
          }
          html += '</form>';
        }

        if (isLoggedIn) {
          html +=
            '<a class="btn wishlist-btn add-to-wishlist test11" href="javascript:;" data-url="' +
            basicUrl +
            'account/wishlistAdd/' +
            product.id +
            '?variant_id=' +
            product.vid +
            '" title="Wishlist" data-id="' +
            product.id +
            '" data-vid="' +
            product.vid +
            '" ><i class="bx bx-heart"></i></a>';
        } else {
          html +=
            '<a class="btn wishlist-btn test16" href="https://www.kristalmeester.nl/nl/account/" title="Login"><i class="bx bx-heart"></i></a>';
        }
      } else {
        // html += '<a class="show-btn quickbuy qb1" href="javascript:;" data-product-url="'+ basicUrl + product.url +'" title="open quickview" data-infinite-quickview-button><span>'+ ajaxTranslations("Quick buy"] +'</span> <i class="bx bx-shopping-bag"></i></a>';
        html +=
          '<a class="open-link hidden" href="#' +
          prodType +
          product.id +
          '" title="' +
          product.fulltitle +
          '" data-fancybox data-infinite-quickview-link>test</a>';
      }

      cur.find('.quickview-button').append(html);
    });
  }
}

function ajaxTranslations(string) {
  return string;
}

var links = document.querySelectorAll('a[aria-controls]');

function toggleDisplay(event) {
  event.preventDefault();

  var targetId = event.currentTarget.getAttribute('aria-controls');
  var targetDiv = document.getElementById(targetId);

  if (targetDiv) {
    if (targetDiv.style.display === 'block') {
      targetDiv.style.display = 'none';
    } else {
      targetDiv.style.display = 'block';
    }
  }
}

links.forEach(function (link) {
  link.addEventListener('click', toggleDisplay);
});

document.body.addEventListener('click', async function (e) {
  if (e.target.classList.contains('add-live')) {
    e.preventDefault();

    const btn = e.target;
    btn.classList.add('disabled');
    btn.setAttribute('aria-busy', 'true');

    const form = btn.closest('form');
    let quantity = 1;
    let url = '';

    if (btn.classList.contains('productpage')) {
      url = form.getAttribute('action');
      quantity = parseInt(form.querySelector('[name="quantity"]').value) || 1;
    } else {
      url = btn.dataset.url;
    }

    const mainProductVid = form.querySelector('[name="variant-id"]').value;

    const btnText = btn.innerHTML;
    btn.innerHTML = '<i class="fa fa-circle-o-notch fa-spin"></i>';

    const type = btn.classList.contains('add-live') ? 'add' : '';

    if (btn.classList.contains('has-options')) {
      const vid = btn.dataset.vid;
      console.log('Option selected with VID:', vid);
    }

    if (btn.classList.contains('productpage')) {
      if (btn.classList.contains('upsell-submit')) {
        const upsellItems = [];
        document.querySelectorAll('.ca-products .ca-products-item').forEach((item) => {
          const productId = item.dataset.productId;
          const input = item.querySelector('.upsell-quantity-input');
          const itemQuantity = input ? parseInt(input.value, 10) : 0;

          if (itemQuantity) {
            upsellItems.push({ id: productId, quantity: itemQuantity });
          }
        });

        await addToCartInBulk(upsellItems);
      }

      const upsellItems = Array.from(document.querySelectorAll('[name="upsell_products[]"]:checked')).map(
        (checkbox) => ({
          id: checkbox.value,
          quantity: quantity,
        })
      );

      upsellItems.push({ id: mainProductVid, quantity });

      const response = await addToCartInBulk(upsellItems);

      if (response && response.status == 422) {
        btn.innerHTML = btnText;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('disabled');
        return;
      }
      updateCart(btn, btnText, type);
    } else {
      const upsellItems = [];
      let properties = {};

      if (document.querySelector('.giftcard__form')) {
        const validationPassed = validateGiftcardForm(form);
        if (!validationPassed) {
          btn.innerHTML = btnText;
          btn.removeAttribute('aria-busy');
          btn.classList.remove('disabled');
          return;
        }

        const nameReceiver = form.querySelector('input[name="_giftcard[name_receiver]"]')?.value || '';
        const emailReceiver = form.querySelector('input[name="_giftcard[email_receiver]"]')?.value || '';
        const nameSender = form.querySelector('input[name="_giftcard[name_sender]"]')?.value || '';
        const shipping = form.querySelector('select[name="_giftcard[shipping]"]')?.value || '';
        const message = form.querySelector('textarea[name="_giftcard[message]"]')?.value || '';

        properties = {
          giftcard: nameReceiver,
          _giftcard: {
            shiping: shipping,
            name_receiver: nameReceiver,
            email_receiver: emailReceiver,
            name_sender: nameSender,
            message: message,
          },
        };
      }

      upsellItems.push({ id: mainProductVid, quantity, properties });

      const response = await addToCartInBulk(upsellItems);
      if (response && response.status == 422) {
        btn.innerHTML = btnText;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('disabled');
        return;
      }
      updateCart(btn, btnText, type);
    }

    btn.innerHTML = btnText;
    btn.removeAttribute('aria-busy');
    btn.classList.remove('disabled');
  }
});

async function addToCartInBulk(items) {
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: items }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    if (response.status === 422) {
      console.error('Error adding items to cart:', response.message);
      liveMessage(response.message, 'error');
      return response;
    }
    // if (!response.ok) {
    //   throw new Error(`Error: ${response.statusText}`);
    //   return;
    // }

    // const data = await response.json();
    console.log('Bulk items added:', response);
    setTimeout(() => {
      $.fancybox.close(true);
    }, 1000);
  } catch (error) {
    console.error('Error adding items to cart:', error);
  }
}

document.body.addEventListener('click', function (e) {
  if (e.target.name === 'clear_upsell_products[]') {
    const clearCheckbox = e.target;
    const customOptions = clearCheckbox.closest('.custom-options');

    if (clearCheckbox.checked) {
      // Deselect all upsell product checkboxes
      customOptions.querySelectorAll('input[name="upsell_products[]"]').forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.closest('.custom-option').classList.remove('active');
      });
    }
  }

  if (e.target.name === 'upsell_products[]' && e.target.checked) {
    const customOptions = e.target.closest('.custom-options');
    customOptions.querySelectorAll('input[name="clear_upsell_products[]"]').forEach((cb) => {
      cb.checked = false;
    });
  }
});

function liveMessage(message, type) {
  // Define icon class based on message type
  let iconClass = '';
  switch (type) {
    case 'error':
      iconClass = 'fa-times';
      break;
    case 'success':
      iconClass = 'fa-check';
      break;
    case 'info':
    default:
      iconClass = 'fa-info';
      break;
  }

  // Remove existing message if present
  const existingMessage = document.querySelector('.live-message');
  if (existingMessage) {
    existingMessage.remove();
  }

  // Create message wrapper
  const messageWrap = document.createElement('div');
  messageWrap.classList.add('message-wrap', 'active', 'live-message');

  // Create message container
  const messageContainer = document.createElement('div');
  messageContainer.classList.add('message', type); // Add type as class (error, success, info)

  // Create icon element
  const iconDiv = document.createElement('div');
  iconDiv.classList.add('icon', type);
  iconDiv.innerHTML = `<i class="fa ${iconClass}"></i>`;

  // Create text container
  const textDiv = document.createElement('div');
  textDiv.classList.add('text');
  textDiv.innerHTML = `<ul><li>${message}</li></ul>`;

  // Append elements together
  messageContainer.appendChild(iconDiv);
  messageContainer.appendChild(textDiv);
  messageWrap.appendChild(messageContainer);

  // Append to body
  document.body.appendChild(messageWrap);

  // Auto-remove after 4 seconds
  setTimeout(() => {
    messageWrap.classList.remove('active');
    setTimeout(() => messageWrap.remove(), 500);
  }, 4000);
}

function validateGiftcardForm(form) {
  let isValid = true;

  const requiredFields = form.querySelectorAll('.giftcard__form input[required], .giftcard__form textarea[required]');

  requiredFields.forEach((field) => {
    const value = field.value.trim();
    const errorText = window.Shopmonkey.translations.field_required;

    let existingError = field.parentElement.querySelector('.error-text');
    if (existingError) {
      existingError.remove();
    }

    if (value === '' || (field.type === 'email' && !validateEmail(value))) {
      isValid = false;
      field.classList.add('error');

      const errorMessage = document.createElement('small');
      errorMessage.classList.add('error-text');
      errorMessage.style.color = 'red';
      errorMessage.textContent = errorText;
      field.parentElement.appendChild(errorMessage);
    } else {
      field.classList.remove('error');
    }
  });

  return isValid;
}

class DeleteProduct extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.addEventListener('click', this.deleteProduct);
  }

  deleteProduct(e) {
    e.preventDefault();
    const item_key = this.dataset?.id || null;
    if (item_key) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: item_key, quantity: 0 }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Product deleted:', data);
          if (data.status === 422) {
            liveMessage(data.message, 'error');
            return;
          }

          updateCart();

          liveMessage
            ? liveMessage(
                data.items_removed[0].product_title + ' ' + window.Shopmonkey.translations.is_removed,
                'success'
              )
            : alert
            ? alert(window.Shopmonkey.translations.product_removed)
            : console.log(window.Shopmonkey.translations.product_removed);
        });
    }
  }
}

customElements.define('delete-product', DeleteProduct);
